import * as moment from 'moment';
import {JSonSerializer} from './JSonSerializer';
import {Utils} from "./Utils";
import {TranslateService} from "@ngx-translate/core";

export class ServerConfiguration {
    server: string;
    download: string;
    downloadContent: string;
    storeSession: boolean;

    version?: Version
    // AlternateUIMode on => Generally no access to server (UI developement)
    alternateUIMode? = false;
    // TestMode on => Generally no access to server (UI developement)
    testMode? = false;
    // dataTest on => Prepopulated Employee's id like in DlgSearchEmployeeComponent
    dataTest? = false;
    //Tracing (CGI)
    traceServer?: string;
    traceActive? = false;
    traceRegistererCode?: string;



  // For Testing purposes.
    username?: string;
    pwd?: string;
}


export class Version{
  version: string;
  build : number;
}



// To Remove
export class JobWithUnit {
  job = new JobInfo();
  unit = new Unit();
}




export class JobInfo {
  jobId: string;
  // jobLabel: string;
  description: string;
  jobExternalId: string;
  exportDivision = '99';
  exportService = '999';
  exportDepartment = '999';
  exportSubDepartment = '999';

  segment1:string;
  segment2:string;
  segment3:string;
  segment4:string;
  segment5:string;
  segment6:string;

  status = DBStatus.ACTIVE;
  bgColor: number;
  sortingOrder: number = 0;


  _createSpecialElement(propertyName: string, data: any): boolean {
    if ('status' === propertyName) {
      this.status = DBStatus.retrieveFromCode(data);
      return true;
    }
    return false;
  }

  get hasColor(): boolean{
    if (!Utils.isNullOrUndefined(this.bgColor)){
      if (this.bgColor!==0){
        return true;
      }
    }
    return false;
  }

  get toHexColor(): string{
    if (this.bgColor === 0){
      return 'transparent';
    }
    let hexColor = Utils.decimalToHexColor(this.bgColor);
    // console.log('Color Bg jobAndUnitEmployee: ' + this.bg + ' hex: ' + hexColor);
    return hexColor;
  }


}

export class JobAndUnitInfo {
  job = new JobInfo();
  unit = new Unit();

  get fullDescription(): string {
    let res = '';
    if ( this.job ) {
      // res += this.job.jobLabel;
      res += this.job.description;
    }
    if ( res.length > 0 ) {
      res += ' - ';
    }
    if ( this.unit ) {
      res += this.unit.description;
    }
    return res;
  }
  get key(): string {
    let res = '';
    if ( this.job ) {
      res += this.job.jobId;
    }
    if ( res.length > 0 ) {
      res += '.';
    }
    if ( this.unit ) {
      res += this.unit.unitCode;
    }
    return res;
  }

  static createKey(jobId: string, unitId: string) {
    return Utils.createKeyJobUnit(jobId,unitId);
  }


}

export class Unit {
   unitCode: string;
   description: string;
   //type: string; // SERVICE, DIVISION, DEPARTEMENT, SOUS_DEPARTEMENT
   type: UnitType;
   parentCode: string;
   rootCode: string;
   externalId: string;
   weekStart: number;
   canSendSMS: boolean;
   smsCredit: number;
   zohoId: string;
   zohoName: string;
   noteSysAdmin: string;

   entityCode: string;
   provState: ProvinceStateCode; // Useful for Division
   country: CountryCode; // Usefull for Division.

  createdBy: string; // employeeId
  createdOn: Date;
  updatedBy: string; // employeeId
  updatedOn: Date;
  extraInfo: string; // Used for ZohoId Matching.

  twilioServiceId: string;//Linked with Twilio (Chat) Service
  classification = IndustryClassification.UNKNOWN;
  hasEmployees = false; // Used in HalfGod

  _createSpecialElement(propertyName: string, data: any): boolean {
    if ('type' === propertyName) {
      this.type = UnitType.retrieveFromCode(data);
      return true;
    }
    if ('provState' === propertyName) {
      this.provState = ProvinceStateCode.retrieveFromCode(data);
      return true;
    }
    if ('country' === propertyName) {
      this.country = CountryCode.retrieveFromCode(data);
      return true;
    }
    if ('classification' === propertyName) {
      this.classification = IndustryClassification.retrieveFromCode(data);
      return true;
    }
    return false;
  }


}


export class Cloneable {

  readProp<T, K extends keyof T>(obj: T, key: K) {
    return obj[key];
  }

  writeProp<T, K extends keyof T>(obj: T, key: K, val: any) {
    obj[key] = val;
  }



  public clone(): any {
    const cloneObj = Object.create(this);
    // const cloneObj = new (<any>this.constructor());

    this.copyFields(cloneObj);
    return cloneObj;

    /*
    for (const propName of Object.getOwnPropertyNames(this)) {
      const propertyType = typeof this[propName];
      if ('object' === propertyType) {
        if (this[propName] === null) {
          continue;
        }
        if (Utils.isNullOrUndefined(this[propName]['clone'])) {
          // console.log('ERROR: clone, cant clone property: ' + this[propName].constructor.name + ' from ' + this.constructor.name);
          this.writeProp(cloneObj, propName, this[propName]);
        } else {
          cloneObj[propName] = (<Cloneable>this[propName]).clone();
        }
      }else {
        this.writeProp(cloneObj, propName, this[propName]);
      }
    }

    return cloneObj;

     */
  }



  public copyFields(copyObj): any {


    for (const propName of Object.getOwnPropertyNames(this)) {
      const propertyType = typeof this[propName];
      if ('object' === propertyType) {
        if (this[propName] === null) {
          continue;
        }
        if (Utils.isNullOrUndefined(this[propName]['clone'])) {
          // console.log('ERROR: clone, cant clone property: ' + this[propName].constructor.name + ' from ' + this.constructor.name);
          this.writeProp(copyObj, propName, this[propName]);
        } else {
          copyObj[propName] = (<Cloneable>this[propName]).clone();
        }
      }else {
        this.writeProp(copyObj, propName, this[propName]);
      }
    }

    return copyObj;
  }


}


export class CustomCode{
  code: string;
  constructor (code: string) {
    this.code = code;
  }
  public toString(): string{
    return this.code;
  }
  public toTranslateKey(): string{
    return this.code;
  }

  public static match(toBeMatch:CustomCode, values:CustomCode[] ):CustomCode{
    if (toBeMatch && values){
        for (const val of values){
          if (val.code === toBeMatch.code){
            toBeMatch = val;
          }
        }
    }
    return toBeMatch;
  }

}


/*
export class CustomCode extends Cloneable{
  code: string;
  constructor (code: string) {
    super();
    this.code = code;
  }
  public toString(): string{
    return this.code;
  }
  public toTranslateKey(): string{
    return this.code;
  }
}

 */


export class UnitType extends  CustomCode{
  private static _registered = new Map<string, UnitType>();

  static SERVICE = new UnitType('SERVICE');
  static DIVISION = new UnitType('DIVISION');
  static DEPARTEMENT = new UnitType('DEPARTEMENT');
  static SOUS_DEPARTEMENT = new UnitType('SOUS_DEPARTEMENT');

  static ALL = [UnitType.DIVISION,UnitType.SERVICE,UnitType.DEPARTEMENT,UnitType.SOUS_DEPARTEMENT];


  static retrieveFromCode(code: string): UnitType {
    const res = UnitType._registered.get(code);
    if (!res) {
      console.log('Hmmm UnitType can\'t find ' + code + ', '+ JSON.stringify(code));
    }
    return res;
  }

  constructor(code: string) {
    super(code);
    UnitType._registered.set(code, this);
  }

  toTranslateKey(): string{
    return "UNIT_TYPE_" + this.code;
  }

  toSubType(): UnitType{
    switch (this){
      case UnitType.DIVISION:
        return UnitType.SERVICE;
      case UnitType.SERVICE:
        return UnitType.DEPARTEMENT;
      case UnitType.DEPARTEMENT:
        return UnitType.SOUS_DEPARTEMENT;
    }
    return null;
  }

}



export class Entity {
  code: string;
  descrEntity: string; // useless ... always horarius
  prefix: string;
  description: string;
  status =  DBStatus.ACTIVE;
  weekNbrYrCalculator:string;
  createdDate: Date;
  updatedDate: Date;
  username: string;


  _createSpecialElement(propertyName: string, data: any): boolean {
    if ('status' === propertyName) {
      this.status = DBStatus.retrieveFromCode(data);
      return true;
    }
    return false;
  }

  public get adminCode(): string{
    if (!Utils.isNullOrUndefined(this.code)){
      // const idx = this.code.indexOf('PROD');
      return 'ADMIN'+this.code.substr(4);
    }
    return "N/A";
  }

  public get active():boolean{
    if (DBStatus.ACTIVE === this.status){
      return true;
    }
    return false
  }

}

export class User {
  username: string;
  employeeCode: string;
  userRole = UsagerRole.NO_ROLE;
  pwd: string;
  status = DBStatus.ACTIVE;
  expiryDt: Date;
  timesheetAccess = false;
  canModifyCostDistribution  =false;
  reservationCode: string;
  canModifyOtherAdmin = false;
  canModifyStructure = false;
  canModifyJob = false;
  canModifyEnterprise = false;
  canModifyCustomReport = false;

  canBeModified = true;
  canReceiveMemo = true;
  canReceiveVacationRequest = true;
  canReceiveAvailabilitiesRequest = true;
  canReceiveWorkshiftExchangeRequest = true;
  canReceiveInitialWorkshiftExchange = false;
  canReceiveFamilyDaysRequest = true;

  secret: string;
  twoFactorAuthentication = false;

  canManageOtherBudget = false;
  canManageDateEvent = false;
  canManageSalesCostObjective = false;
  canManageGeoFence = false;
  canManageBankType = false;
  canDeleteEmployee = false;
  canLockTimesheet = false;
  canUnlockAllTimesheet = false;
  canManageExpenseType = false;
  canManageEvaluation = false;
  canSendMemoToSameLevelUser = false;

  lastLoginDate:Date;
  canPrintOrSendCredentials = true;
  constructor (){

  }


  _createSpecialElement(propertyName: string, data: any): boolean {
    if ('userRole' === propertyName) {
      this.userRole = UsagerRole.retrieveFromCode(data);
      return true;
    }
    if ('status' === propertyName) {
      this.status = DBStatus.retrieveFromCode(data);
      return true;
    }
    return false;
  }

  isRoleMoreThanEmployee():boolean{
    if (this.userRole){
      if (this.userRole.level > UsagerRole.DEMO_EMPLOYEE.level){
        return true;
      }
    }

    return false;
  }



}

export class AvailableUserAggregation {
  users = new Array<UserAggregationAndDivision>();
  divisions = new Array<Unit>();

  _createFromArray(propertyName: string, data: any) {
    const serializer = new JSonSerializer();
    if ('users' === propertyName) {
      for (const bean of <UserAggregationAndDivision[]> data) {
        const tmp = new UserAggregationAndDivision();
        serializer.deserialize(bean, tmp);
        this.users.push(tmp);
      }
    }
    if ('divisions' === propertyName) {
      for (const bean of <Unit[]> data) {
        const tmp = new Unit();
        serializer.deserialize(bean, tmp);
        this.divisions.push(tmp);
      }
    }
  }
}

export class Employee {
  id: string;
  externalId: string; // contains nethris id for example...
  externalId2: string; // Nethris needs a second Id for the Person... No comment.
  lname: string;
  fname: string;
  fnamePreferred : string;
  sex: SexType;
  lang: LangueType;
  adr: string;
  city: string;
  postalCode: string;
  provState: ProvinceStateCode;
  country: CountryCode;
  tel1: string;
  tel2: string;
  telCell: string;
  telPage: string;
  bdate: Date;
  email: string;
  professionalEmail: string;
  nas: string;
  civilStatus: string;
  noteDispo: string;
  calendarId: string;
  visible = true;
  includeInPerformance = true;
  calendarTz = HorariusTimeZone.CA_EASTERN;
  posId: string;


  _createSpecialElement(propertyName: string, data: any) {
    if ('provState' === propertyName) {
      this.provState = ProvinceStateCode.retrieveFromCode(data);
      return true;
    }
    if ('country' === propertyName) {
      this.country = CountryCode.retrieveFromCode(data);
      return true;
    }
    if ('sex' === propertyName) {
      this.sex = SexType.retrieveFromCode(data);
      return true;
    }
    if ('lang' === propertyName) {
      this.lang = LangueType.retrieveFromCode(data);
      return true;
    }
    if ('calendarTz' === propertyName) {
      this.calendarTz = HorariusTimeZone.retrieveFromCode(data);
      return true;
    }

    return false;
  }



  get fullName(): string {
    // console.log(' ' + this.fname + ' ' + this.lname);
    if ( !this.fname ) {
      if ( this.lname ) {
        return this.lname;
      }else {
        return '';
      }
    }
    if (!this.lname) {
      return this.fname;
    }
    return this.lname + ' ' + this.fname;
  }

}

export class UserAggregationAndDivision {

  user = new User();
  employee = new Employee();
  divisionIds = new Array<string>();

  _createFromArray(propertyName: string, data: any) {
    if ('divisionIds' === propertyName) {
      for (const bean of <string[]> data) {
        this.divisionIds.push(bean);
      }
    }
  }

  containThisDivisionId(divisionID: string): boolean {
    for (const id of this.divisionIds){
      if (id === divisionID) {
         return true;
      }
    }
    return false;
  }

}

export class NumberIds {
  old: number;
  current: number;
}

export class ResultWithNumberIds {
  saved: NumberIds[];
  workShiftBonusSaved: NumberIds[];
  timedTaskSaved : NumberIds[];
  deleted: number[];
}

export class JSonResult<T>{
    success: boolean;
    description?: string;
    data?: T;
    paging?: EmprezPaging;
}

export class EmprezPaging{
  from: number;
  pageSize: number;
  hasMore = true;
}


export class UsagerRole extends CustomCode {
  private static _registered = new Map<string, UsagerRole>();

  /*
	USER (UsagerRoleConst.USER), 			//Responsable
	READ_ONLY (UsagerRoleConst.READ_ONLY), 	//Responsable (Limite)
	DEMO (UsagerRoleConst.DEMO), 				//Employe
	EXECUTIVE(UsagerRoleConst.EXECUTIVE), 			//Administrateur (Limite)
	ADMIN (UsagerRoleConst.ADMIN), 		//Administrateur
	SYS_ADMIN (UsagerRoleConst.SYS_ADMIN), 	//SysAdmin
	REP(UsagerRoleConst.REP); 				//Representant


   */

  static PUNCH = new UsagerRole('PUNCH', 1);
  static USER_REPONSABLE = new UsagerRole('USER', 30); // Responsable
  static READ_ONLY_LIMITED_REPONSABLE = new UsagerRole('READ_ONLY', 20); // Responsable (Limite)
  static DEMO_EMPLOYEE = new UsagerRole('DEMO', 2 ); // Employe
  static EXECUTIVE_LIMITED_ADMIN = new UsagerRole('EXECUTIVE', 40); // Administrateur (Limite)
  static ADMIN = new UsagerRole('ADMIN', 50); // Administrateur
  static SYS_ADMIN = new UsagerRole('SYS_ADMIN', 100); // SysADMIN
 // static REP = new UsagerRole('REP', 10); // Representant.

  static NO_ROLE = new UsagerRole('NO_ROLE', 0); // Representant.


  level: number;
  constructor (code: string, level: number) {
    super(code);
    this.level = level;
    UsagerRole._registered.set(code, this);
  }

  retrieveCodeForTranslate() {
    return 'USER_ROLE_' + this.code;
  }

  static retrieveRoleForCreation(currentRole: UsagerRole, adminThatCanModifyOrCreateOtherAdmin): UsagerRole[] {
     const res = new Array<UsagerRole>();
      if (currentRole) {
        for (const role of Array.from(UsagerRole._registered.values())){
          //Special Case with ADMIN
          if ((UsagerRole.ADMIN === role) && (UsagerRole.SYS_ADMIN !== currentRole)){
            // Not Adding the ADMIN role if you are not allowed to createOrModifyOtherAdmins.
            // Ask by Robin.
            if (Utils.isNullOrUndefined(adminThatCanModifyOrCreateOtherAdmin) ||  !adminThatCanModifyOrCreateOtherAdmin){
              continue;
            }
          }
          if ((role.level > 1) && (role.level <= currentRole.level)) {
             res.push(role);
          }
        }
      }
    return res;
  }


  static retrieveFromCode(code: string): UsagerRole {
    let res = UsagerRole.NO_ROLE;
      if (code) {
        switch (code) {
          case 'PUNCH':
            res = UsagerRole.PUNCH;break;
          case 'USER':
            res =  UsagerRole.USER_REPONSABLE;break;
          case 'READ_ONLY':
            res =  UsagerRole.READ_ONLY_LIMITED_REPONSABLE;break;
          case 'DEMO':
            res =  UsagerRole.DEMO_EMPLOYEE;break;
          case 'EXECUTIVE':
            res =  UsagerRole.EXECUTIVE_LIMITED_ADMIN;break;
          case 'ADMIN':
            res =  UsagerRole.ADMIN;break;
          case 'SYS_ADMIN':
            res = UsagerRole.SYS_ADMIN;break;
          // case 'REP':
          //   res= UsagerRole.REP; break;
          default:
            res = UsagerRole.NO_ROLE;
        }
      }
       // console.log('UsagerRole ' + code + ' type: ' + typeof(code) + ' is ' + res);
      return res;
  }
}

export class DBStatus extends CustomCode {
  static ACTIVE = new DBStatus('ACTIVE', true);
  static INACTIVE = new DBStatus('INACTIVE', false);
  booleanValue: boolean;
  constructor (code: string, value: boolean) {
    super(code);
    this.booleanValue = value;
  }

  retrieveCodeForTranslate() {
    return 'DB_STATUS_' + this.code;
  }

  static retrieveFromCode(code: string): DBStatus {
    switch (code) {
      case 'ACTIVE': return DBStatus.ACTIVE;
      case 'INACTIVE': return DBStatus.INACTIVE;
    }
    console.log('Can\'t find DBStatus code: ' + code + ' Object: ' + JSON.stringify(code,null,2));
    return DBStatus.INACTIVE;
  }

  static retrieveFromBoolean(value: boolean): DBStatus {
    if (value) {
      return DBStatus.ACTIVE;
    }
    return DBStatus.INACTIVE;
  }

  public get toBoolean(): boolean {
    return this.booleanValue;
  }

}

export class MaskFormats {
  static DURATION_22 = [ /\d/, /\d/, ':', /\d/, /\d/ ];
  static HOUR_MIN = [ /\d/, /\d/, /\d/, ':', /\d/, /\d/ ];
  static HOUR_MIN_MAX = [ /\d/,/\d/, /\d/, /\d/, ':', /\d/, /\d/ ];
  static HOUR_MIN_MAX_PLUS = [ /\d/,/\d/,/\d/, /\d/, /\d/, ':', /\d/, /\d/ ];
  static HOUR_MIN_MAX_PLUS_POSITIVE_NEGATIVE = [/[+,-]/, /\d/,/\d/,/\d/, /\d/, /\d/, ':', /\d/, /\d/ ];
  static NORTH_AMERICA_PHONE_MASK = [ '(', /\d/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/ ];
  static FRENCH_PHONE_MASK = [ /\d/, /\d/, ' ', /\d/, /\d/, ' ', /\d/, /\d/, ' ', /\d/, /\d/, ' ', /\d/, /\d/];

  static CANADIAN_NAS_FORMAT = [  /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/ ];
  static FRENCH_NAS_FORMAT = [  /\d/, ' ', /\d/, /\d/, ' ', /\d/, /\d/, ' ', /\d/, /\d/, ' ', /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, ' ', /\d/, /\d/];

  static INTERVAL_HOUR_FORMAT_24 = [ /[0-2]/, /\d/, ':',  /[0,3]/, /[0]/, ' ', '-', ' ',  /[0-2]/, /\d/, ':',  /[0,3]/, /[0]/];
  static INTERVAL_HOUR_FORMAT_AM_PM = [ /[0,1]/, /\d/, ':',  /[0,3]/, /[0]/, ' ', /[a,A,p,P]/, /[m,M]/, ' ', '-', ' ',  /[0,1]/, /\d/, ':',  /[0,3]/, /[0]/, ' ', /[a,A,p,P]/, /[m,M]/];

  // static INTERVAL_HOUR_FORMAT_24_FOR_TASK = [ /[0-2]/, /\d/, ':',  /[0,3]/, /[0]/, ' ', '-', ' ',  /[0-2]/, /\d/, ':',  /[0,3]/, /[0]/,',',/./,/./,/./,/./,/./,/./,/./];
  // static INTERVAL_HOUR_FORMAT_AM_PM_FOR_TASK = [ /[0,1]/, /\d/, ':',  /[0,3]/, /[0]/, ' ', /[a,A,p,P]/, /[m,M]/, ' ', '-', ' ',  /[0,1]/, /\d/, ':',  /[0,3]/, /[0]/, ' ', /[a,A,p,P]/, /[m,M]/,',',/./,/./,/./,/./,/./,/./,/./];

  static INTERVAL_HOUR_FORMAT_24_FOR_TASK = [ /[0-2]/, /\d/, ':',  /[0-5]/, /[0,5]/, ' ', '-', ' ',  /[0-2]/, /\d/, ':',  /[0-5]/, /[0,5]/,',',/./,/./,/./,/./,/./,/./,/./];
  static INTERVAL_HOUR_FORMAT_AM_PM_FOR_TASK = [ /[0,1]/, /\d/, ':',  /[0-5]/, /[0,5]/, ' ', /[a,A,p,P]/, /[m,M]/, ' ', '-', ' ',  /[0,1]/, /\d/, ':',  /[0-5]/, /[0,5]/, ' ', /[a,A,p,P]/, /[m,M]/,',',/./,/./,/./,/./,/./,/./,/./];

  static INTERVAL_HOUR_FORMAT_24_FOR_TASK_PLUS = [ /[0-2]/, /\d/, ':',  /[0-5]/, /[0,5]/, ' ', '-', ' ',  /[0-2]/, /\d/, ':',  /[0-5]/, /[0,5]/,',',/./,/./,/./,/./,/./,/./,/./,/./,/./,/./,/./,/./,/./,/./,/./,/./,/./,/./,/./,/./,/./,/./,/./,/./,/./,/./,/./,/./,/./,/./,/./,/./,/./,/./,/./];
  static INTERVAL_HOUR_FORMAT_AM_PM_FOR_TASK_PLUS = [ /[0,1]/, /\d/, ':',  /[0-5]/, /[0,5]/, ' ', /[a,A,p,P]/, /[m,M]/, ' ', '-', ' ',  /[0,1]/, /\d/, ':',  /[0-5]/, /[0,5]/, ' ', /[a,A,p,P]/, /[m,M]/,',',/./,/./,/./,/./,/./,/./,/./,/./,/./,/./,/./,/./,/./,/./,/./,/./,/./,/./,/./,/./,/./,/./,/./,/./,/./,/./,/./,/./,/./,/./,/./,/./,/./,/./,/./];


  static INTERVAL_HOUR_FORMAT_24_5_MINUTES = [ /[0-2]/, /\d/, ':',  /[0-5]/, /[0,5]/, ' ', '-', ' ',  /[0-2]/, /\d/, ':',  /[0-5]/, /[0,5]/];
  static INTERVAL_HOUR_FORMAT_AM_PM_5_MINUTES = [ /[0,1]/, /\d/, ':',  /[0-5]/, /[0,5]/, ' ', /[a,A,p,P]/, /[m,M]/, ' ', '-', ' ',  /[0,1]/, /\d/, ':',  /[0-5]/, /[0,5]/, ' ', /[a,A,p,P]/, /[m,M]/];

  static INTERVAL_HOUR_FORMAT_24_ANY_MINUTES = [ /[0-2]/, /\d/, ':',  /[0-5]/,/\d/, ' ', '-', ' ',  /[0-2]/, /\d/, ':',  /[0-5]/, /\d/];
  static INTERVAL_HOUR_FORMAT_AM_PM_ANY_MINUTES = [ /[0,1]/, /\d/, ':',  /[0-5]/, /\d/, ' ', /[a,A,p,P]/, /[m,M]/, ' ', '-', ' ',  /[0,1]/, /\d/, ':',  /[0-5]/, /\d/, ' ', /[a,A,p,P]/, /[m,M]/];


  static HOUR_FORMAT_24 = [ /[0-2]/, /\d/, ':',  /[0,3]/, /[0]/];
  static HOUR_FORMAT_AM_PM = [ /[0,1]/, /\d/, ':',  /[0,3]/, /[0]/, ' ', /[a,A,p,P]/, /[m,M]/];
  static HOUR_FORMAT_24_5_MINUTES = [ /[0-2]/, /\d/, ':',  /[0-5]/, /[0,5]/];
  static HOUR_FORMAT_AM_PM_5_MINUTES = [ /[0,1]/, /\d/, ':',  /[0-5]/, /[0,5]/, ' ', /[a,A,p,P]/, /[m,M]/];



  static HOUR_FORMAT_24_ANY_MINUTES_SECONDS = [ /[0-2]/, /\d/, ':',  /[0-5]/, /\d/,':',  /[0-5]/, /\d/];
  static HOUR_FORMAT_24_ANY_MINUTES = [ /[0-2]/, /\d/, ':',  /[0-5]/, /\d/];
  static HOUR_FORMAT_AM_PM_ANY_MINUTES = [ /[0,1]/, /\d/, ':',  /[0-5]/, /\d/, ' ', /[a,A,p,P]/, /[m,M]/];


  public static maskForPhoneByCountryCode(country: CountryCode): (RegExp | string)[] {
    if (!Utils.isNullOrUndefined(country)) {
      if (CountryCode.FRANCE === country) {
        return MaskFormats.FRENCH_PHONE_MASK;
      }
    }
    return MaskFormats.NORTH_AMERICA_PHONE_MASK;
  }


  public static maskForPhone(country: string): (RegExp | string)[] {
    if (!Utils.isNullOrUndefined(country)) {
      if ('FRANCE' === country.toUpperCase()) {
        return MaskFormats.FRENCH_PHONE_MASK;
      }
    }
    return MaskFormats.NORTH_AMERICA_PHONE_MASK;
  }

  public static maskForNAS(country: string): (RegExp | string)[] {
    if (!Utils.isNullOrUndefined(country)) {
      if (country.toUpperCase() === 'FRANCE') {
        return MaskFormats.FRENCH_NAS_FORMAT;
      }
    }
    return MaskFormats.CANADIAN_NAS_FORMAT;
  }


}

export class PreferenceAppel extends CustomCode {
  static TEL_1 = new PreferenceAppel('TELEPHONE_PRINCIPAL');
  static TEL_2 = new PreferenceAppel('TELEPHONE_SECONDAIRE');
  static CELL = new PreferenceAppel('CELLULAIRE');
  static EMAIL = new PreferenceAppel('EMAIL');
  static PROFESSIONAL_EMAIL = new PreferenceAppel("PROFESSIONAL_EMAIL");

  static PAGE = new PreferenceAppel('PAGE');
  static SMS = new PreferenceAppel('SMS');

  static retrieveFromCode(code: string): PreferenceAppel {
    switch (code) {
      case 'TELEPHONE_PRINCIPAL': return PreferenceAppel.TEL_1;
      case 'TELEPHONE_SECONDAIRE': return PreferenceAppel.TEL_2;
      case 'CELLULAIRE': return PreferenceAppel.CELL;
      case 'EMAIL': return PreferenceAppel.EMAIL;
      case 'PROFESSIONAL_EMAIL': return PreferenceAppel.PROFESSIONAL_EMAIL;
      case 'PAGE': return PreferenceAppel.PAGE;
      case 'SMS': return PreferenceAppel.SMS;
    }
    return null;
  }

  public toString(): string {
    return this.code;
  }

}

export class SexType extends  CustomCode{
  static MALE = new SexType('MALE');
  static FEMALE = new SexType('FEMALE');
  static ALL = [SexType.FEMALE, SexType.MALE ];

  static retrieveFromCode(code: string): SexType {
    switch (code) {
      case 'MALE': return SexType.MALE;
      case 'FEMALE': return SexType.FEMALE;
    }
    return null;
  }
}

// FRANCAIS ("fr"),
//   ANGLAIS("en"),
//   ALLEMAND("de"),
//   ESPAGNOL("es");

export class LangueType extends CustomCode{
  static FRANCAIS = new LangueType('FRANCAIS');
  static ANGLAIS = new LangueType('ANGLAIS');
  static ESPAGNOL =new LangueType('ESPAGNOL');
  static ALL = [LangueType.FRANCAIS, LangueType.ANGLAIS,LangueType.ESPAGNOL ];

  static retrieveFromCode(code: string): LangueType {
    switch (code) {
      case 'FRANCAIS': return LangueType.FRANCAIS;
      case 'ANGLAIS': return LangueType.ANGLAIS;
      case 'ESPAGNOL': return LangueType.ESPAGNOL;
    }
    return null;
  }

}


export class ProvinceStateCode extends CustomCode {

  private static _registered = new Map<string, ProvinceStateCode>();
  private static _registeredIso = new Map<string, ProvinceStateCode>();

  isoCode: string;


  static retrieveFromCode(code: string): ProvinceStateCode {
    const res = ProvinceStateCode._registered.get(code);
    if (!res) {
      console.log('Hmmm ProvinceStateCode can\'t find ' + code);
    }
    return res;
  }


  static retrieveByIsoCode(isoCode: string): ProvinceStateCode {
    const res = ProvinceStateCode._registeredIso.get(isoCode);
    if (!res) {
      console.log('Hmmm ProvinceStateCode can\'t find ' + isoCode);
    }
    return res;
  }

  constructor(code: string, isoCode: string) {
    super(code);
    this.isoCode = isoCode;
    ProvinceStateCode._registered.set(code, this);
    ProvinceStateCode._registeredIso.set(isoCode, this);
   // console.log('Registering ' + code + ': ' + this.isoCode);
  }

  public toString(): string {
    return this.code;
  }



}

export class CountryCode extends  CustomCode{
  private static _registered = new Map<string, CountryCode>();
  private static _registeredIso = new Map<string, CountryCode>();

  static CANADA = new CountryCode('CANADA','CA');
  static FRANCE = new CountryCode('FRANCE','FR');
  static USA = new CountryCode('USA','US');

  static ALL = [CountryCode.CANADA, CountryCode.FRANCE, CountryCode.USA ];


  isoCode: string;


  static retrieveFromCode(code: string): CountryCode {
    let res = CountryCode._registered.get(code);
    if (!res) {
      if (!Utils.isNullOrUndefined(code)){
        res = CountryCode._registered.get(code.toString().toUpperCase());
      }
      if (!res) {
        console.log('Hmmm CountryCode can\'t find ' + code + ', '+ JSON.stringify(code));
      }
    }
    return res;
  }


  static retrieveByIsoCode(isoCode: string): CountryCode {
    const res = CountryCode._registeredIso.get(isoCode);
    if (!res) {
      console.log('Hmmm CountryCode can\'t find ' + isoCode);
    }
    return res;
  }

  constructor(code: string, isoCode: string) {
    super(code);
    this.isoCode = isoCode;
    CountryCode._registered.set(code, this);
    CountryCode._registeredIso.set(isoCode, this);
    // console.log('Registering ' + code + ': ' + this.isoCode);
  }

  public toString(): string {
    return this.code;
  }

}

export class ProvinceCode extends ProvinceStateCode {
  static ALBERTA = new ProvinceStateCode('ALBERTA', 'AB');
  static BRITISH_COLUMBIA  = new ProvinceStateCode('BRITISH_COLUMBIA', 'BC' );
  static MANITOBA = new ProvinceStateCode('MANITOBA', 'MB' );
  static NEW_BRUNSWICK = new ProvinceStateCode('NEW_BRUNSWICK', 'NB' );
  static NEWFOUNDLAND = new ProvinceStateCode('NEWFOUNDLAND', 'NL' );
  static NOVA_SCOTIA = new ProvinceStateCode('NOVA_SCOTIA', 'NS' );
  static ONTARIO = new ProvinceStateCode('ONTARIO', 'ON' );
  static PEI = new ProvinceStateCode('PEI', 'PE' );
  static QUEBEC = new ProvinceStateCode('QUEBEC', 'QC' );

  static NORTHERN_TERRITORY = new ProvinceStateCode('NORTHERN_TERRITORY', 'NT');
  static NUNAVUT = new ProvinceStateCode('NUNAVUT', 'NN');
  static YUKON = new ProvinceStateCode('YUKON', 'YK');

  static SASKATCHEWAN = new ProvinceStateCode('SASKATCHEWAN', 'SK');


  static ALL = [ProvinceCode.ALBERTA, ProvinceCode.BRITISH_COLUMBIA,
  ProvinceCode.MANITOBA, ProvinceCode.NEW_BRUNSWICK, ProvinceCode.NEWFOUNDLAND, ProvinceCode.NOVA_SCOTIA,
    ProvinceCode.NUNAVUT, ProvinceCode.NORTHERN_TERRITORY,
    ProvinceCode.ONTARIO, ProvinceCode.PEI, ProvinceCode.QUEBEC, ProvinceCode.SASKATCHEWAN,ProvinceCode.YUKON
  ];


}

export class USStateCode extends  ProvinceStateCode {

  static ALABAMA = new ProvinceStateCode('ALABAMA', 'AL' );
  static ALASKA = new ProvinceStateCode('ALASKA', 'AK' );
  static AMERICAN_SAMOA = new ProvinceStateCode('AMERICAN_SAMOA', 'AS' );
  static ARIZONA = new ProvinceStateCode('ARIZONA', 'AZ' );
  static ARKANSAS = new ProvinceStateCode('ARKANSAS', 'AR' );
  static CALIFORNIA = new ProvinceStateCode('CALIFORNIA', 'CA' );

  static COLORADO = new ProvinceStateCode('COLORADO', 'CO' );
  static CONNECTICUT = new ProvinceStateCode('CONNECTICUT', 'CT' );
  static DELAWARE = new ProvinceStateCode('DELAWARE', 'DE' );
  static DIST_OF_COLUMBIA = new ProvinceStateCode('DIST_OF_COLUMBIA', 'DC' );
  static FLORIDA = new ProvinceStateCode('FLORIDA', 'FL' );
  static GEORGIA = new ProvinceStateCode('GEORGIA', 'GA' );
  static GUAM = new ProvinceStateCode('GUAM', 'GU' );
  static HAWAII = new ProvinceStateCode('HAWAII', 'HI' );
  static IDAHO = new ProvinceStateCode('IDAHO', 'ID' );
  static ILLINOIS = new ProvinceStateCode('ILLINOIS', 'IL' );
  static INDIANA = new ProvinceStateCode('INDIANA', 'IN' );
  static IOWA = new ProvinceStateCode('IOWA', 'IO' );
  static KANSAS = new ProvinceStateCode('KANSAS', 'KS' );
  static KENTUCKY = new ProvinceStateCode('KENTUCKY', 'KY' );
  static LOUISIANA = new ProvinceStateCode('LOUISIANA', 'LA' );
  static MAINE = new ProvinceStateCode('MAINE', 'ME' );
  static MARYLAND = new ProvinceStateCode('MARYLAND', 'MD' );

  static MARSHALL_ISLANDS = new ProvinceStateCode('MARSHALL_ISLANDS', 'MH' );
  static MASSACHUSETTS = new ProvinceStateCode('MASSACHUSETTS', 'MA' );
  static MICHIGAN = new ProvinceStateCode('MICHIGAN', 'MI' );
  static MICRONESIA = new ProvinceStateCode('MICRONESIA', 'FM' );
  static MINNESOTA = new ProvinceStateCode('MINNESOTA', 'MN' );
  static MISSISSIPPI = new ProvinceStateCode('MISSISSIPPI', 'MS' );
  static MISSOURI = new ProvinceStateCode('MISSOURI', 'MO' );
  static MONTANA = new ProvinceStateCode('MONTANA', 'MT' );
  static NEBRASKA = new ProvinceStateCode('NEBRASKA', 'NE' );
  static NEVADA = new ProvinceStateCode('NEVADA', 'NV' );
  static NEW_HAMPSHIRE = new ProvinceStateCode('NEW_HAMPSHIRE', 'NH' );
  static NEW_JERSEY = new ProvinceStateCode('NEW_JERSEY', 'NJ' );
  static NEW_MEXICO = new ProvinceStateCode('NEW_MEXICO', 'NM' );
  static NEW_YORK = new ProvinceStateCode('NEW_YORK', 'NY' );
  static NORTH_CAROLINA = new ProvinceStateCode('NORTH_CAROLINA', 'NC' );
  static NORTH_DAKOTA = new ProvinceStateCode('NORTH_DAKOTA', 'ND' );
  static NOTHERN_MARIANAS = new ProvinceStateCode('NOTHERN_MARIANAS', 'MP' );
  static OHIO = new ProvinceStateCode('OHIO', 'OH' );
  static OKLAHOMA = new ProvinceStateCode('OKLAHOMA', 'OK' );
  static OREGON = new ProvinceStateCode('OREGON', 'OR' );
  static PALAU = new ProvinceStateCode('PALAU', 'PW' );
  static PENNSYLVANIA = new ProvinceStateCode('PENNSYLVANIA', 'PA' );
  static PUERTO_RICO = new ProvinceStateCode('PUERTO_RICO', 'PR' );
  static RHODE_ISLAND = new ProvinceStateCode('RHODE_ISLAND', 'RI' );
  static SOUTH_CAROLINA = new ProvinceStateCode('SOUTH_CAROLINA', 'SC' );
  static SOUTH_DAKOTA = new ProvinceStateCode('SOUTH_DAKOTA', 'SD' );
  static TENNESSEE = new ProvinceStateCode('TENNESSEE', 'TN' );
  static TEXAS = new ProvinceStateCode('TEXAS', 'TX' );
  static UTAH = new ProvinceStateCode('UTAH', 'UT' );
  static VERMONT = new ProvinceStateCode('VERMONT', 'VT' );
  static VIRGINIA = new ProvinceStateCode('VIRGINIA', 'VA' );
  static VIRGIN_ISLANDS = new ProvinceStateCode('VIRGIN_ISLANDS', 'VI' );
  static WASHINGTON = new ProvinceStateCode('WASHINGTON', 'WA' );
  static WEST_VIRGINIA = new ProvinceStateCode('WEST_VIRGINIA', 'WV' );
  static WISCONSIN = new ProvinceStateCode('WISCONSIN', 'WI' );
  static WYOMING = new ProvinceStateCode('WYOMING', 'WY');



  static ALL = [USStateCode.ALABAMA, USStateCode.ALASKA, USStateCode.AMERICAN_SAMOA, USStateCode.ARIZONA, USStateCode.ARKANSAS,
    USStateCode.CALIFORNIA, USStateCode.COLORADO, USStateCode.CONNECTICUT,
    USStateCode.DELAWARE, USStateCode.DIST_OF_COLUMBIA,
    USStateCode.FLORIDA,
    USStateCode.GEORGIA, USStateCode.GUAM, USStateCode.HAWAII,
    USStateCode.IDAHO, USStateCode.ILLINOIS, USStateCode.INDIANA, USStateCode.IOWA,
    USStateCode.KANSAS, USStateCode.KENTUCKY, USStateCode.LOUISIANA,
    USStateCode.MAINE, USStateCode.MARSHALL_ISLANDS, USStateCode.MARYLAND, USStateCode.MASSACHUSETTS,
    USStateCode.MICHIGAN, USStateCode.MICRONESIA, USStateCode.MINNESOTA, USStateCode.MISSISSIPPI, USStateCode.MONTANA,
    USStateCode.NEBRASKA, USStateCode.NEVADA, USStateCode.NEW_HAMPSHIRE, USStateCode.NEW_JERSEY, USStateCode.NEW_MEXICO, USStateCode.NEW_YORK,
    USStateCode.NORTH_CAROLINA, USStateCode.NORTH_DAKOTA, USStateCode.NOTHERN_MARIANAS,
    USStateCode.OHIO, USStateCode.OKLAHOMA, USStateCode.OREGON,
    USStateCode.PALAU, USStateCode.PENNSYLVANIA, USStateCode.PUERTO_RICO,
    USStateCode.RHODE_ISLAND,
    USStateCode.SOUTH_CAROLINA, USStateCode.SOUTH_DAKOTA,
    USStateCode.TENNESSEE, USStateCode.TEXAS,
    USStateCode.UTAH,
    USStateCode.VERMONT,
    USStateCode.VIRGIN_ISLANDS, USStateCode.VIRGINIA,
    USStateCode.WASHINGTON,USStateCode.WISCONSIN,
    USStateCode.WYOMING
  ];


}


export class FrenchDepartmentCode extends  ProvinceStateCode {
  static AIN = new ProvinceStateCode('AIN', 'FR-01');
  static AISNE = new ProvinceStateCode('AISNE', 'FR-02');
  static ALLIER = new ProvinceStateCode('ALLIER', 'FR-03');
  static ALPES_DE_HAUTE_PROVENCE = new ProvinceStateCode('ALPES_DE_HAUTE_PROVENCE', 'FR-04');
  static HAUTES_ALPES = new ProvinceStateCode('HAUTES_ALPES', 'FR-05');
  static ALPES_MARITIMES = new ProvinceStateCode('ALPES_MARITIMES', 'FR-06');
  static ARDECHE = new ProvinceStateCode('ARDECHE', 'FR-07');
  static ARDENNES = new ProvinceStateCode('ARDENNES', 'FR-08');
  static ARIEGE = new ProvinceStateCode('ARIEGE', 'FR-09');
  static AUBE = new ProvinceStateCode('AUBE', 'FR-10');
  static AUDE = new ProvinceStateCode('AUDE', 'FR-11');
  static AVEYRON = new ProvinceStateCode('AVEYRON', 'FR-12');
  static BOUCHES_DU_RHONE = new ProvinceStateCode('BOUCHES_DU_RHONE', 'FR-13');
  static CALVADOS = new ProvinceStateCode('CALVADOS', 'FR-14');
  static CANTAL = new ProvinceStateCode('CANTAL', 'FR-15');
  static CHARENTE = new ProvinceStateCode('CHARENTE', 'FR-16');
  static CHARENTE_MARITIME = new ProvinceStateCode('CHARENTE_MARITIME', 'FR-17');
  static CHER = new ProvinceStateCode('CHER', 'FR-18');
  static CORREZE = new ProvinceStateCode('CORREZE', 'FR-19');
  static CORSE_DU_SUD = new ProvinceStateCode('CORSE_DU_SUD', 'FR-2A');
  static HAUTE_CORSE = new ProvinceStateCode('HAUTE_CORSE', 'FR-2B');
  static COTE_D_OR = new ProvinceStateCode('COTE_D_OR', 'FR-21');
  static COTES_D_ARMOR = new ProvinceStateCode('COTES_D_ARMOR', 'FR-22');
  static CREUSE = new ProvinceStateCode('CREUSE', 'FR-23');
  static DORDOGNE = new ProvinceStateCode('DORDOGNE', 'FR-24');
  static DOUBS = new ProvinceStateCode('DOUBS', 'FR-25');
  static DROME = new ProvinceStateCode('DROME', 'FR-26');
  static EURE = new ProvinceStateCode('EURE', 'FR-27');
  static EURE_ET_LOIR = new ProvinceStateCode('EURE_ET_LOIR', 'FR-28');
  static FINISTERE = new ProvinceStateCode('FINISTERE', 'FR-29');
  static GARD = new ProvinceStateCode('GARD', 'FR-30');
  static HAUTE_GARONNE = new ProvinceStateCode('HAUTE_GARONNE', 'FR-31');
  static GERS = new ProvinceStateCode('GERS', 'FR-32');
  static GIRONDE = new ProvinceStateCode('GIRONDE', 'FR-33');
  static HERAULT = new ProvinceStateCode('HERAULT', 'FR-34');
  static ILLE_ET_VILAINE = new ProvinceStateCode('ILLE_ET_VILAINE', 'FR-35');
  static INDRE = new ProvinceStateCode('INDRE', 'FR-36');
  static INDRE_ET_LOIRE = new ProvinceStateCode('INDRE_ET_LOIRE', 'FR-37');
  static ISERE = new ProvinceStateCode('ISERE', 'FR-38');
  static JURA = new ProvinceStateCode('JURA', 'FR-39');
  static LANDES = new ProvinceStateCode('LANDES', 'FR-40');
  static LOIR_ET_CHER = new ProvinceStateCode('LOIR_ET_CHER', 'FR-41');
  static LOIRE = new ProvinceStateCode('LOIRE', 'FR-42');
  static HAUTE_LOIRE = new ProvinceStateCode('HAUTE_LOIRE', 'FR-43');
  static LOIRE_ATLANTIQUE = new ProvinceStateCode('LOIRE_ATLANTIQUE', 'FR-44');
  static LOIRET = new ProvinceStateCode('LOIRET', 'FR-45');
  static LOT = new ProvinceStateCode('LOT', 'FR-46');
  static LOT_ET_GARONNE = new ProvinceStateCode('LOT_ET_GARONNE', 'FR-47');
  static LOZERE = new ProvinceStateCode('LOZERE', 'FR-48');
  static MAINE_ET_LOIRE = new ProvinceStateCode('MAINE_ET_LOIRE', 'FR-49');
  static MANCHE = new ProvinceStateCode('MANCHE', 'FR-50');
  static MARNE = new ProvinceStateCode('MARNE', 'FR-51');
  static HAUTE_MARNE = new ProvinceStateCode('HAUTE_MARNE', 'FR-52');
  static MAYENNE = new ProvinceStateCode('MAYENNE', 'FR-53');
  static MEURTHE_ET_MOSELLE = new ProvinceStateCode('MEURTHE_ET_MOSELLE', 'FR-54');
  static MEUSE = new ProvinceStateCode('MEUSE', 'FR-55');
  static MORBIHAN = new ProvinceStateCode('MORBIHAN', 'FR-56');
  static MOSELLE = new ProvinceStateCode('MOSELLE', 'FR-57');
  static NIEVRE = new ProvinceStateCode('NIEVRE', 'FR-58');
  static NORD = new ProvinceStateCode('NORD', 'FR-59');
  static OISE = new ProvinceStateCode('OISE', 'FR-60');
  static ORNE = new ProvinceStateCode('ORNE', 'FR-61');
  static PAS_DE_CALAIS = new ProvinceStateCode('PAS_DE_CALAIS', 'FR-62');
  static PUY_DE_DOME = new ProvinceStateCode('PUY_DE_DOME', 'FR-63');
  static PYRENEES_ATLANTIQUES = new ProvinceStateCode('PYRENEES_ATLANTIQUES', 'FR-64');
  static HAUTES_PYRENEES = new ProvinceStateCode('HAUTES_PYRENEES', 'FR-65');
  static PYRENEES_ORIENTALES = new ProvinceStateCode('PYRENEES_ORIENTALES', 'FR-66');
  static BAS_RHIN = new ProvinceStateCode('BAS_RHIN', 'FR-67');
  static HAUT_RHIN = new ProvinceStateCode('HAUT_RHIN', 'FR-68');
  static RHONE = new ProvinceStateCode('RHONE', 'FR-69D');
  static METROPOLE_DE_LYON = new ProvinceStateCode('METROPOLE_DE_LYON', 'FR-69M');
  static HAUTE_SAONE = new ProvinceStateCode('HAUTE_SAONE', 'FR-70');
  static SAONE_ET_LOIRE = new ProvinceStateCode('SAONE_ET_LOIRE', 'FR-71');
  static SARTHE = new ProvinceStateCode('SARTHE', 'FR-72');
  static SAVOIE = new ProvinceStateCode('SAVOIE', 'FR-73');
  static HAUTE_SAVOIE = new ProvinceStateCode('HAUTE_SAVOIE', 'FR-74');
  static PARIS = new ProvinceStateCode('PARIS', 'FR-75');
  static SEINE_MARITIME = new ProvinceStateCode('SEINE_MARITIME', 'FR-76');
  static SEINE_ET_MARNE = new ProvinceStateCode('SEINE_ET_MARNE', 'FR-77');
  static YVELINES = new ProvinceStateCode('YVELINES', 'FR-78');
  static DEUX_SEVRES = new ProvinceStateCode('DEUX_SEVRES', 'FR-79');
  static SOMME = new ProvinceStateCode('SOMME', 'FR-80');
  static TARN = new ProvinceStateCode('TARN', 'FR-81');
  static TARN_ET_GARONNE = new ProvinceStateCode('TARN_ET_GARONNE', 'FR-82');
  static VAR = new ProvinceStateCode('VAR', 'FR-83');
  static VAUCLUSE = new ProvinceStateCode('VAUCLUSE', 'FR-84');
  static VENDEE = new ProvinceStateCode('VENDEE', 'FR-85');
  static VIENNE = new ProvinceStateCode('VIENNE', 'FR-86');
  static HAUTE_VIENNE = new ProvinceStateCode('HAUTE_VIENNE', 'FR-87');
  static VOSGES = new ProvinceStateCode('VOSGES', 'FR-88');
  static YONNE = new ProvinceStateCode('YONNE', 'FR-89');
  static TERRITOIRE_DE_BELFORT = new ProvinceStateCode('TERRITOIRE_DE_BELFORT', 'FR-90');
  static ESSONNE = new ProvinceStateCode('ESSONNE', 'FR-91');
  static HAUTS_DE_SEINE = new ProvinceStateCode('HAUTS_DE_SEINE', 'FR-92');
  static SEINE_SAINT_DENIS = new ProvinceStateCode('SEINE_SAINT_DENIS', 'FR-93');
  static VAL_DE_MARNE = new ProvinceStateCode('VAL_DE_MARNE', 'FR-94');
  static VAL_D_OISE = new ProvinceStateCode('VAL_D_OISE', 'FR-95');
  static GUADELOUPE = new ProvinceStateCode('GUADELOUPE', 'FR-971');
  static MARTINIQUE = new ProvinceStateCode('MARTINIQUE', 'FR-972');
  static GUYANE = new ProvinceStateCode('GUYANE', 'FR-973');
  static LA_REUNION = new ProvinceStateCode('LA_REUNION', 'FR-974');
  static MAYOTTE = new ProvinceStateCode('MAYOTTE', 'FR-976');


  static ALL = [
    FrenchDepartmentCode.AIN,
    FrenchDepartmentCode.AISNE,
    FrenchDepartmentCode.ALLIER,
    FrenchDepartmentCode.ALPES_DE_HAUTE_PROVENCE,
    FrenchDepartmentCode.ALPES_MARITIMES,
    FrenchDepartmentCode.ARDECHE,
    FrenchDepartmentCode.ARDENNES,
    FrenchDepartmentCode.ARIEGE,
    FrenchDepartmentCode.AUBE,
    FrenchDepartmentCode.AUDE,
    FrenchDepartmentCode.AVEYRON,
    FrenchDepartmentCode.BAS_RHIN,
    FrenchDepartmentCode.BOUCHES_DU_RHONE,
    FrenchDepartmentCode.CALVADOS,
    FrenchDepartmentCode.CANTAL,
    FrenchDepartmentCode.CHARENTE,
    FrenchDepartmentCode.CHARENTE_MARITIME,
    FrenchDepartmentCode.CHER,
    FrenchDepartmentCode.CORREZE,
    FrenchDepartmentCode.CORSE_DU_SUD,
    FrenchDepartmentCode.COTE_D_OR,
    FrenchDepartmentCode.COTES_D_ARMOR,
    FrenchDepartmentCode.CREUSE,
    FrenchDepartmentCode.DEUX_SEVRES,
    FrenchDepartmentCode.DORDOGNE,
    FrenchDepartmentCode.DOUBS,
    FrenchDepartmentCode.DROME,
    FrenchDepartmentCode.ESSONNE,
    FrenchDepartmentCode.EURE,
    FrenchDepartmentCode.EURE_ET_LOIR,
    FrenchDepartmentCode.FINISTERE,
    FrenchDepartmentCode.GARD,
    FrenchDepartmentCode.GERS,
    FrenchDepartmentCode.GIRONDE,
    FrenchDepartmentCode.GUADELOUPE,
    FrenchDepartmentCode.GUYANE,
    FrenchDepartmentCode.HAUTE_CORSE,
    FrenchDepartmentCode.HAUTE_GARONNE,
    FrenchDepartmentCode.HAUTE_LOIRE,
    FrenchDepartmentCode.HAUTE_MARNE,
    FrenchDepartmentCode.HAUTE_SAONE,
    FrenchDepartmentCode.HAUTE_SAVOIE,
    FrenchDepartmentCode.HAUTE_VIENNE,
    FrenchDepartmentCode.HAUTES_ALPES,
    FrenchDepartmentCode.HAUTES_PYRENEES,
    FrenchDepartmentCode.HAUTS_DE_SEINE,
    FrenchDepartmentCode.HAUT_RHIN,
    FrenchDepartmentCode.HERAULT,
    FrenchDepartmentCode.ILLE_ET_VILAINE,
    FrenchDepartmentCode.INDRE,
    FrenchDepartmentCode.INDRE_ET_LOIRE,
    FrenchDepartmentCode.ISERE,
    FrenchDepartmentCode.JURA,
    FrenchDepartmentCode.LA_REUNION,
    FrenchDepartmentCode.LANDES,
    FrenchDepartmentCode.LOIR_ET_CHER,
    FrenchDepartmentCode.LOIRE,
    FrenchDepartmentCode.LOIRE_ATLANTIQUE,
    FrenchDepartmentCode.LOIRET,
    FrenchDepartmentCode.LOT,
    FrenchDepartmentCode.LOT_ET_GARONNE,
    FrenchDepartmentCode.LOZERE,
    FrenchDepartmentCode.MAINE_ET_LOIRE,
    FrenchDepartmentCode.MANCHE,
    FrenchDepartmentCode.MARNE,
    FrenchDepartmentCode.MARTINIQUE,
    FrenchDepartmentCode.MAYENNE,
    FrenchDepartmentCode.MAYOTTE,
    FrenchDepartmentCode.METROPOLE_DE_LYON,
    FrenchDepartmentCode.MEURTHE_ET_MOSELLE,
    FrenchDepartmentCode.MEUSE,
    FrenchDepartmentCode.MORBIHAN,
    FrenchDepartmentCode.MOSELLE,
    FrenchDepartmentCode.NIEVRE,
    FrenchDepartmentCode.NORD,
    FrenchDepartmentCode.OISE,
    FrenchDepartmentCode.ORNE,
    FrenchDepartmentCode.PARIS,
    FrenchDepartmentCode.PAS_DE_CALAIS,
    FrenchDepartmentCode.PUY_DE_DOME,
    FrenchDepartmentCode.PYRENEES_ATLANTIQUES,
    FrenchDepartmentCode.PYRENEES_ORIENTALES,
    FrenchDepartmentCode.RHONE,
    FrenchDepartmentCode.SAONE_ET_LOIRE,
    FrenchDepartmentCode.SARTHE,
    FrenchDepartmentCode.SAVOIE,
    FrenchDepartmentCode.SEINE_ET_MARNE,
    FrenchDepartmentCode.SEINE_MARITIME,
    FrenchDepartmentCode.SEINE_SAINT_DENIS,
    FrenchDepartmentCode.SOMME,
    FrenchDepartmentCode.TARN,
    FrenchDepartmentCode.TARN_ET_GARONNE,
    FrenchDepartmentCode.TERRITOIRE_DE_BELFORT,
    FrenchDepartmentCode.VAL_D_OISE,
    FrenchDepartmentCode.VAL_DE_MARNE,
    FrenchDepartmentCode.VAR,
    FrenchDepartmentCode.VAUCLUSE,
    FrenchDepartmentCode.VENDEE,
    FrenchDepartmentCode.VIENNE,
    FrenchDepartmentCode.VOSGES,
    FrenchDepartmentCode.YONNE,
    FrenchDepartmentCode.YVELINES,
  ];


}




export class HiringStatus extends CustomCode {
  static CONTRACTUEL = new HiringStatus('CONTRACTUEL');
  static PERMANENT = new HiringStatus('PERMANENT');
  static PROBATION = new HiringStatus('PROBATION');

  static STAGIAIRE = new HiringStatus('STAGIAIRE');
  static SUBVENTIONNE = new HiringStatus('SUBVENTIONNE');
  static TEMPORAIRE = new HiringStatus('TEMPORAIRE');
  static OCCASIONNEL = new HiringStatus('OCCASIONNEL');
  static TEMPORAIRE80 = new HiringStatus('TEMPORAIRE80');

  static ALL = [HiringStatus.CONTRACTUEL, HiringStatus.PERMANENT, HiringStatus.PROBATION,
                HiringStatus.STAGIAIRE, HiringStatus.SUBVENTIONNE,
                HiringStatus.TEMPORAIRE, HiringStatus.OCCASIONNEL, HiringStatus.TEMPORAIRE80]

  static retrieveFromCode(code: string): HiringStatus {
    switch (code) {
      case 'CONTRACTUEL': return HiringStatus.CONTRACTUEL;
      case 'PERMANENT': return HiringStatus.PERMANENT;
      case 'PROBATION': return HiringStatus.PROBATION;

      case 'STAGIAIRE': return HiringStatus.STAGIAIRE;
      case 'SUBVENTIONNE': return HiringStatus.SUBVENTIONNE;
      case 'TEMPORAIRE': return HiringStatus.TEMPORAIRE;
      case 'OCCASIONNEL': return HiringStatus.OCCASIONNEL;
      case 'TEMPORAIRE80': return HiringStatus.TEMPORAIRE80;
    }
    return null;
  }


}

export class ScheduleStatus extends CustomCode {
  static SUR_APPEL = new ScheduleStatus('SUR_APPEL');
  static TEMPS_COMPLET = new ScheduleStatus('TEMPS_COMPLET');
  static TEMPS_PARTIEL = new ScheduleStatus('TEMPS_PARTIEL');

  static ALL = [ScheduleStatus.SUR_APPEL, ScheduleStatus.TEMPS_COMPLET, ScheduleStatus.TEMPS_PARTIEL];
  static retrieveFromCode(code: string): ScheduleStatus {
    switch (code) {
      case 'SUR_APPEL': return ScheduleStatus.SUR_APPEL;
      case 'TEMPS_COMPLET': return ScheduleStatus.TEMPS_COMPLET;
      case 'TEMPS_PARTIEL': return ScheduleStatus.TEMPS_PARTIEL;
    }
    return null;
  }

  public toString(): string {
    return this.code;
  }

}

/*
	SUR_APPEL (""),
	TEMPS_COMPLET(""),
	TEMPS_PARTIEL("");


 */


export class HiringType extends CustomCode {
  private static _registered = new Map<string, HiringType>();

  static EMBAUCHE = new HiringType('EMBAUCHE');
  static DEPART = new HiringType('DEPART');
  static ARRET_TRAVAIL = new HiringType('ARRET_TRAVAIL');
  static RETOUR_TRAVAIL = new HiringType('RETOUR_TRAVAIL');

  static ALL = Array.from(HiringType._registered.values());



  constructor(code: string) {
    super(code);
    HiringType._registered.set(code, this);
  }

  static retrieveFromCode(code: string): HiringType {
    switch (code) {
      case 'EMBAUCHE': return HiringType.EMBAUCHE;
      case 'DEPART': return HiringType.DEPART;
      case 'ARRET_TRAVAIL': return HiringType.ARRET_TRAVAIL;
      case 'RETOUR_TRAVAIL': return HiringType.RETOUR_TRAVAIL;
    }
    return null;
  }


  public isEmployeeActive(): boolean{
    let res = false;
    // console.log('isEmployeeActive: ' +  this.code);
    switch (this) {
      case HiringType.EMBAUCHE:
        res = true;
        break;
      case HiringType.DEPART:
        res = false;
        break;
      case HiringType.RETOUR_TRAVAIL:
        res = true;
        break;
      default:
        res = false;
        break;
    }

    return res;
  }


  public toString(): string {
    return this.code;
  }

}

export class ReasonType extends CustomCode {

  private static _registered = new Map<string, ReasonType>();
  // static TEL_1 = new PreferenceAppel(
  static A_MANQUE_TRAVAIL = new ReasonType('A_MANQUE_TRAVAIL', 'A');
  static B_BREVE_LOCKOUT = new ReasonType('B_GREVE_LOCKOUT', 'B');
  static C_RETOUR_ETUDES = new ReasonType('C_RETOUR_ETUDES', 'C');
  static D_MALADIE_BLESS = new ReasonType('D_MALADIE_BLESS', 'D');
  static E_DEPART_VOLONTAIRE = new ReasonType('E_DEPART_VOLONTAIRE', 'E');
  static F_GROSSESSE_PAR = new ReasonType('F_GROSSESSE_PAR', 'F');
  static G_RETRAITE = new ReasonType('G_RETRAITE', 'G');
  static H_TRAVAIL_PARTAGE = new ReasonType('H_TRAVAIL_PARTAGE', 'H');
  static J_FORMATION = new ReasonType('J_FORMATION', 'J');
  static K_AUTRE = new ReasonType('K_AUTRE', 'K');
  static M_CONGEDIEMENT = new ReasonType('M_CONGEDIEMENT', 'M');
  static N_CONGE_SANS_SOLDE = new ReasonType('N_CONGE_SANS_SOLDE', 'N');
  static P_PARENTAL = new ReasonType('P_PARENTAL', 'P');
  static Z_COMPASSION= new ReasonType('Z_COMPASSION', 'Z');

  static ALL = Array.from(ReasonType._registered.values());


  shortCode: string;


  constructor(code: string, shortCode: string) {
    super(code);
    this.shortCode = shortCode;
    ReasonType._registered.set(code, this);
  }

  public toString(): string {
    return this.code;
  }

  static retrieveFromCode(code: string): ReasonType {
    const res = ReasonType._registered.get(code);
    if (!res) {
      console.log('Hmmm ReasonType can\'t find ' + code);
    }
    return res;
  }


}




export class HoraireRoundingMode extends CustomCode {
  private static _registered = new Map<string, HoraireRoundingMode>();
  static UP = new HoraireRoundingMode('UP');
  static DOWN = new HoraireRoundingMode('DOWN');
  static HALF_UP = new HoraireRoundingMode('HALF_UP');

  static ALL = Array.from(HoraireRoundingMode._registered.values());


  static retrieveFromCode(code: string): HoraireRoundingMode {
    const res = HoraireRoundingMode._registered.get(code);
    if (!res) {
      console.log('Hmmm HoraireRoundingMode can\'t find ' + code);
    }
    return res;
  }

  constructor(code: string) {
    super(code);
    HoraireRoundingMode._registered.set(code, this);
  }

  public toString(): string {
    return this.code;
  }


  public toTranslateKey(): string{
    return 'HORAIRE_ROUNDING_MODE_' + this.code;
  }

}


export class HolidayCalculationType extends CustomCode {
  private static _registered = new Map<string, HolidayCalculationType>();
  static ONE_TEN_LAST_PAY = new HolidayCalculationType('1','ONE_TEN_LAST_PAY');
  static ONE_TWENTY_FOUR_PAY = new HolidayCalculationType('2','ONE_TWENTY_FOUR_PAY');
  static ONE_SIXTY_TWELVE_PAY = new HolidayCalculationType('6','ONE_SIXTY_TWELVE_PAY');
  static ONE_SIXTEEN_FOUR__PAY = new HolidayCalculationType('3','ONE_SIXTEEN_FOUR__PAY');
  static STATIC = new HolidayCalculationType('S', 'STATIC');

  static ONE_20_4_PAY_W_BANKS = new HolidayCalculationType('ONE_20_4_PAY_W_BANKS','ONE_20_4_PAY_W_BANKS');

  static ALBERTA = new HolidayCalculationType('ALBERTA', 'ALBERTA');
  static BRITISH_COLUMBIA = new HolidayCalculationType('BRITISH_COLUMBIA', 'BRITISH_COLUMBIA');
  static MANITOBA = new HolidayCalculationType('MANITOBA', 'MANITOBA');
  static NEW_BRUNSWICK = new HolidayCalculationType('NEW_BRUNSWICK', 'NEW_BRUNSWICK');
  static NEWFOUNDLAND = new HolidayCalculationType('NEWFOUNDLAND', 'NEWFOUNDLAND');
  static NOVA_SCOTIA = new HolidayCalculationType('NOVA_SCOTIA','NOVA_SCOTIA');
  static NUNAVUT = new HolidayCalculationType('NUNAVUT', 'NUNAVUT');
  static ONTARIO = new HolidayCalculationType('ONTARIO', 'ONTARIO');
  static ONTARIO_2018 = new HolidayCalculationType('ONTARIO_2018','ONTARIO_2018');
  static PEI = new HolidayCalculationType('PEI', 'PEI');
  static YUKON = new HolidayCalculationType('YUKON', 'YUKON');

  static CALC_FROM_LAST_PAY = new HolidayCalculationType('CALC_FROM_LAST_PAY', 'CALC_FROM_LAST_PAY');
  static CALC_4_WEEKS_PAY = new HolidayCalculationType('CALC_4_WEEKS_PAY', 'CALC_4_WEEKS_PAY');

  static ONE_12_4_WEEK_3DAY = new HolidayCalculationType('ONE_12_4_WEEK_3DAY', 'ONE_12_4_WEEK_3DAY');



  static ALL = Array.from(HolidayCalculationType._registered.values());
  static CALCULATE_FAMILY_LEAVE = [HolidayCalculationType.ONE_TEN_LAST_PAY,
    HolidayCalculationType.ONE_TWENTY_FOUR_PAY,HolidayCalculationType.ONE_SIXTY_TWELVE_PAY,HolidayCalculationType.ONE_SIXTEEN_FOUR__PAY];

  javaCode: string;

  static retrieveFromCode(code: string): HolidayCalculationType {
    const res = HolidayCalculationType._registered.get(code);
    if (!res) {
      console.log('Hmmm HolidayCalculationType can\'t find ' + code);
    }
    return res;
  }

  constructor(javaCode: string, code: string ) {
    super(code);
    this.javaCode = javaCode;
    HolidayCalculationType._registered.set(code, this);
  }


  public toString(): string {
    return this.code;
  }


  public toTranslateKey(): string{
    return 'HOLIDAY_CALCULATION_TYPE_' + this.javaCode;
  }
}

export class ExportPaieType extends CustomCode {


  private static _registered = new Map<string, ExportPaieType>();
  private static _registeredWithCode = new Map<string, ExportPaieType>();
  static NETHRIS = new ExportPaieType('1','NETHRIS');
  static ACOMBA = new ExportPaieType('2','ACOMBA');

  static AVANTAGE = new ExportPaieType('3','AVANTAGE');
  static DESJARDINS = new ExportPaieType('4','DESJARDINS');
  static PAIE_PC = new ExportPaieType('5','PAIE_PC');
  static PAYWEB = new ExportPaieType('6','PAYWEB');
  static SIMPLE_COMPTABLE = new ExportPaieType('7','SIMPLE_COMPTABLE');
  static ADP = new ExportPaieType('8','ADP');
  static SAGES = new ExportPaieType('9','SAGES');

  static ROCHELEAU = new ExportPaieType('10','ROCHELEAU');
  static CYTRONICS = new ExportPaieType('11','CYTRONICS');
  static SCQC = new ExportPaieType('12','SCQC');
  static HOPEM = new ExportPaieType('13','HOPEM');

  static MAGIKPAY = new ExportPaieType('14','MAGIKPAY');
  static SCQC_GC = new ExportPaieType('15','SCQC_GC');
  static ACCEO = new ExportPaieType('16','ACCEO');
  static POWERPAY_CERIDIAN = new ExportPaieType('17','POWERPAY_CERIDIAN');
  static EASY_PAY = new ExportPaieType('18','EASY_PAY');
  static OGASYS = new ExportPaieType('19','OGASYS');
  static AZUR = new ExportPaieType('20','AZUR');

  static HOPEM_PLUS = new ExportPaieType('21','HOPEM_PLUS');
  static ULTIMATE = new ExportPaieType('22','ULTIMATE');

  static NETHRIS_SPLIT = new ExportPaieType('23','NETHRIS_SPLIT');
  static DESJARDINS_SPLIT = new ExportPaieType('24','DESJARDINS_SPLIT');
  static HOPEM_VALEO_SEDNA = new ExportPaieType('25','HOPEM_VALEO_SEDNA');

  static PAY_WORKS = new ExportPaieType('26','PAY_WORKS');
  static TITAN = new ExportPaieType('27','TITAN');
  static SAGE50 = new ExportPaieType('28','SAGE50');
  static QUICKBOOKS_TIME = new ExportPaieType('29','QUICKBOOKS_TIME');

  static EMPREZ = new ExportPaieType('30','EMPREZ');
  static DYNACOM = new ExportPaieType('31','DYNACOM');
  static ON_TRACK = new ExportPaieType('32','ON_TRACK');
  static ADP_SPLIT = new ExportPaieType('33','ADP_SPLIT');
  static HARVEST = new ExportPaieType('34','HARVEST');

  static ALL = Array.from(ExportPaieType._registered.values());

  private javaCode : string;

  static retrieveFromJavaCode(javaCode: string): ExportPaieType {
    let res = ExportPaieType._registered.get(javaCode);
    if (Utils.isNullOrUndefined(res)) {
      res = ExportPaieType._registeredWithCode.get(javaCode);
      if (Utils.isNullOrUndefined(res)){
        console.log('Hmmm ExportPaieType can\'t find ' + javaCode);
      }
    }
    return res;
  }

  constructor(code: string, javaCode: string) {
    super(javaCode);
    this.javaCode = code;

    ExportPaieType._registered.set(javaCode, this);
    ExportPaieType._registeredWithCode.set(code,this);
  }

  public toString(): string {
    return this.code;
  }


  public toTranslateKey(): string{
    return 'EXPORT_PAY_TYPE_' + this.javaCode;
  }
}

export class PayPeriodType extends CustomCode {

  private static _registered = new Map<string, PayPeriodType>();
  private static _registeredWithCode = new Map<string, PayPeriodType>();
  static WEEKLY = new PayPeriodType('1', 'WEEKLY');
  static TWO_WEEK = new PayPeriodType('2', 'TWO_WEEK');


  static ALL = Array.from(PayPeriodType._registered.values());
  private javaCode: string;

  static retrieveFromCode(javaCode: string): PayPeriodType {
    let res = PayPeriodType._registered.get(javaCode);
    if (Utils.isNullOrUndefined(res)) {
      res = PayPeriodType._registeredWithCode.get(javaCode);
      if (Utils.isNullOrUndefined(res)){
        console.log('Hmmm PayPeriodType can\'t find ' + javaCode);
      }
    }
    return res;
  }

  constructor(code: string, javaCode: string) {
    super(javaCode);
    this.javaCode = code;
    PayPeriodType._registered.set(javaCode, this);
    PayPeriodType._registeredWithCode.set(code,this);
  }

  public toString(): string {
    return this.code;
  }

  public toTranslateKey(): string{
    return 'PAY_PERIOD_TYPE' + this.javaCode;
  }

}


export class PayCompilationType extends CustomCode {


  private static _registered = new Map<string, PayCompilationType>();
  private static _registeredWithCode = new Map<string, PayCompilationType>();
  static WEEKLY = new PayCompilationType('1', 'WEEKLY');
  static TWO_WEEK = new PayCompilationType('2', 'TWO_WEEK');
  static WEEK_1_ONLY = new PayCompilationType('WEEK_1_ONLY', 'WEEK_1_ONLY');
  static WEEK_2_ONLY = new PayCompilationType('WEEK_2_ONLY', 'WEEK_2_ONLY');


  static ALL = Array.from(PayCompilationType._registered.values());
  private javaCode: string;

  static retrieveFromCode(javaCode: string): PayCompilationType {
    let res = PayCompilationType._registered.get(javaCode);
    if (Utils.isNullOrUndefined(res)) {
      res = PayCompilationType._registeredWithCode.get(javaCode);
      if (Utils.isNullOrUndefined(res)){
        console.log('Hmmm PayCompilationType can\'t find ' + javaCode);
      }
    }
    return res;
  }

  constructor(code: string, javaCode: string) {
    super(javaCode);
    this.javaCode = code;
    PayCompilationType._registered.set(javaCode, this);
    PayCompilationType._registeredWithCode.set(code,this);
  }

  public toString(): string {
    return this.code;
  }

  public toTranslateKey(): string{
    return 'PAY_COMPILATION_TYPE_' + this.code;
  }

}


export class UsableWageType extends CustomCode {

  private static _registered = new Map<string, UsableWageType>();
  static MANUAL = new UsableWageType('1', 'MANUAL');
  static REMUNERATION = new UsableWageType('2', 'REMUNERATION');
  static WAGE_PER_PERIOD = new UsableWageType('3', 'WAGE_PER_PERIOD');



  static ALL = Array.from(UsableWageType._registered.values());
   private dbCode: string;

  static retrieveFromCode(code: string): UsableWageType {
    const res = UsableWageType._registered.get(code);
    if (!res) {
      console.log('Hmmm UsableWageType can\'t find ' + code);
    }
    return res;
  }

  constructor(dbCode: string, code: string) {
    super(code);
    this.dbCode = dbCode;
    UsableWageType._registered.set(code, this);
  }

  public toString(): string {
    return this.code;
  }


  public toTranslateKey(): string{
    return 'USABLE_WAGE_' + this.dbCode;
  }

}




export class JobStatusType extends CustomCode {

  private static _registered = new Map<string, JobStatusType>();
  static REGULAR = new JobStatusType('1', 'REGULAR');
  static REDUCED = new JobStatusType('2', 'REDUCED');


  static ALL = Array.from(JobStatusType._registered.values());
  private dbCode: string;
  static retrieveFromCode(code: string): JobStatusType {
    const res = JobStatusType._registered.get(code);
    if (!res) {
      console.log('Hmmm JobStatusType can\'t find ' + code);
    }
    return res;
  }

  constructor(dbCode: string, code: string) {
    super(code);
    this.dbCode = dbCode;
    JobStatusType._registered.set(code, this);
  }

  public toString(): string {
    return this.code;
  }


  public toTranslateKey(): string{
    return 'JOB_STATUS_' + this.dbCode;
  }

}


export class PaymentModeType extends CustomCode {

  private static _registered = new Map<string, PaymentModeType>();
  static CHECK = new PaymentModeType('1', 'CHECK');
  static DEPOSIT = new PaymentModeType('2', 'DEPOSIT');
  static MEMO = new PaymentModeType('2', 'MEMO');


  static ALL = Array.from(PaymentModeType._registered.values());
  private dbCode: string;
  static retrieveFromCode(code: string): PaymentModeType {
    const res = PaymentModeType._registered.get(code);
    if (!res) {
      console.log('Hmmm PaymentModeType can\'t find ' + code);
    }
    return res;
  }

  constructor(dbCode: string, code: string) {
    super(code);
    this.dbCode = dbCode;
    PaymentModeType._registered.set(code, this);
  }

  public toString(): string {
    return this.code;
  }

  public toTranslateKey(): string {
    return 'PAYMENT_MODE_' + this.dbCode;
  }

}



export class BaseFederalExemptionType extends CustomCode {

  private static _registered = new Map<string, BaseFederalExemptionType>();
  static BASE_AMOUT = new BaseFederalExemptionType('1','BASE_AMOUT');
  static NO_TAX = new BaseFederalExemptionType('2','NO_TAX');
  static NO_EXEMPTION = new BaseFederalExemptionType('3','NO_EXEMPTION');



  static ALL = Array.from(BaseFederalExemptionType._registered.values());
  private dbCode: string;


  static retrieveFromCode(code: string): BaseFederalExemptionType {
    const res = BaseFederalExemptionType._registered.get(code);
    if (!res) {
      console.log('Hmmm BaseFederalExemptionType can\'t find ' + code);
    }
    return res;
  }

  constructor(dbCode: string, code: string) {
    super(code);
    this.dbCode = dbCode;
    BaseFederalExemptionType._registered.set(code, this);
  }

  public toString(): string {
    return this.code;
  }

  public toTranslateKey(): string{
    return 'BASE_FEDERAL_EXEMPTION_' + this.dbCode;
  }
}



export class BaseProvincialExemptionType extends CustomCode {

  private static _registered = new Map<string, BaseProvincialExemptionType>();
  static BASE_AMOUT_QC = new BaseProvincialExemptionType('1','BASE_AMOUT_QC');
  static NO_TAX_QC = new BaseProvincialExemptionType('2','NO_TAX_QC');
  static NO_EXEMPTION_QC = new BaseProvincialExemptionType('3','NO_EXEMPTION_QC');
  static BASE_AMOUT = new BaseProvincialExemptionType('4','BASE_AMOUT');
  static NO_TAX = new BaseProvincialExemptionType('5','NO_TAX');
  static NO_EXEMPTION = new BaseProvincialExemptionType('6','NO_EXEMPTION');


  private dbCode: string;
  static ALL = Array.from(BaseProvincialExemptionType._registered.values());

  static retrieveFromCode(code: string): BaseProvincialExemptionType {
    const res = BaseProvincialExemptionType._registered.get(code);
    if (!res) {
      console.log('Hmmm BaseProvincialExemptionType can\'t find ' + code);
    }
    return res;
  }

  constructor(dbCode: string, code: string) {
    super(code);
    this.dbCode = dbCode;
    BaseProvincialExemptionType._registered.set(code, this);
  }

  public toString(): string {
    return this.code;
  }

  public toTranslateKey(): string{
    return 'BASE_PROVINCE_EXEMPTION_' + this.dbCode;
  }
}

/**
 * That's legacy from Horarius
 */
export class HorariusLocale extends CustomCode{
  public static _registered = new Map<string, HorariusLocale>();
  static FR_CA = new HorariusLocale('fr_CA');
  static EN_CA = new HorariusLocale('en_CA');
  static ES = new HorariusLocale('es');

  static ALL = Array.from(HorariusLocale._registered.values());


  constructor(code: string) {
    super(code);
    HorariusLocale._registered.set(code, this);
  }
  static retrieveFromCode(code: string): HorariusLocale {
    const res = HorariusLocale._registered.get(code);
    if (!res) {
       console.log('HorariusLocale can\'t be found with code: ' + code);
       return null;
    }
    return res;
  }

  public toTranslateKey(): string{
    return 'HORARIUS_LOCALE_' + this.code;
  }

}

/**
 * Legacy from Horarius, Java based denomination
 */
export class HorariusTimeZone extends CustomCode{
  public static _registered = new Map<string, HorariusTimeZone>();

  static  CA_EASTERN = new HorariusTimeZone('Canada/Eastern');
  static  CA_ATLANTIC = new HorariusTimeZone('Canada/Atlantic');
  static  CA_CENTRAL = new HorariusTimeZone('Canada/Central');
  static  CA_MOUNTAIN = new HorariusTimeZone('Canada/Mountain');
  static  CA_PACIFIC = new HorariusTimeZone('Canada/Pacific');

  static  CA_NEWFOUNDLAND = new HorariusTimeZone('Canada/Newfoundland');
  static  CA_EAST_SASKATCHEWAN = new HorariusTimeZone('Canada/East-Saskatchewan');
  static  CA_SASKATCHEWAN = new HorariusTimeZone('Canada/Saskatchewan');
  static  CA_YUKON = new HorariusTimeZone('Canada/Yukon');


  static  CENTRAL_EUROPEAN = new HorariusTimeZone('Europe/Paris');
  static  EUROPE_MOSCOW = new HorariusTimeZone('Europe/Moscow');

  static  WEST_AFRICA = new HorariusTimeZone('Africa/Algiers');


  static ALL = Array.from(HorariusTimeZone._registered.values());

  constructor(code: string) {
    super(code);
    HorariusTimeZone._registered.set(code, this);
  }
  static retrieveFromCode(code: string): HorariusTimeZone {
    const res = HorariusTimeZone._registered.get(code);
    if (!res) {
      console.log('HorariusTimeZone can\'t be found with code: ' + code);
      return null;
    }
    return res;
  }

  public toTranslateKey(): string{
    return this.code;
  }
}


/**
 * Legacy from Horarius, Java based denomination
 */
export class HorariusTimeZoneForPunchConfig extends CustomCode{
  public static _registered = new Map<string, HorariusTimeZoneForPunchConfig>();

  static  CA_EASTERN = new HorariusTimeZoneForPunchConfig('CA_EASTERN','Canada/Eastern');
  static  CA_ATLANTIC = new HorariusTimeZoneForPunchConfig('CA_ATLANTIC','Canada/Atlantic');
  static  CA_CENTRAL = new HorariusTimeZoneForPunchConfig('CA_CENTRAL','Canada/Central');
  static  CA_MOUNTAIN = new HorariusTimeZoneForPunchConfig('CA_MOUNTAIN','Canada/Mountain');
  static  CA_PACIFIC = new HorariusTimeZoneForPunchConfig('CA_PACIFIC','Canada/Pacific');
  static  CA_YUKON = new HorariusTimeZoneForPunchConfig('CA_YUKON','Canada/Yukon');
  static  CA_EAST_SASKATCHEWAN = new HorariusTimeZoneForPunchConfig('CA_EAST_SASKATCHEWAN','Canada/East-Saskatchewan');
  static  CA_SASKATCHEWAN = new HorariusTimeZoneForPunchConfig('CA_SASKATCHEWAN','Canada/Saskatchewan');
  static  CA_NEWFOUNDLAND = new HorariusTimeZoneForPunchConfig('CA_NEWFOUNDLAND','Canada/Newfoundland');

  static  CENTRAL_EUROPEAN = new HorariusTimeZoneForPunchConfig('CENTRAL_EUROPEAN','Europe/Paris');
  static  EUROPE_MOSCOW = new HorariusTimeZoneForPunchConfig('EUROPE_MOSCOW','Europe/Moscow');
  static  WEST_AFRICA = new HorariusTimeZoneForPunchConfig('WEST_AFRICA','Africa/Algiers');






  /*


	(""),
	(""),
	(""),
	(""),
	CENTRAL_EUROPEAN("Europe/Paris");

  */

  private _javaCode: string;
  static ALL = Array.from(HorariusTimeZoneForPunchConfig._registered.values());

  constructor(code: string,javaCode: string) {
    super(code);
    this._javaCode = javaCode;
    HorariusTimeZoneForPunchConfig._registered.set(code, this);
  }
  static retrieveFromCode(code: string): HorariusTimeZoneForPunchConfig {
    const res = HorariusTimeZoneForPunchConfig._registered.get(code);
    if (!res) {
      console.log('HorariusTimeZoneForPunchConfig can\'t be found with code: ' + code);
      return null;
    }
    return res;
  }

  public toTranslateKey(): string{
    return this.code;
  }
}



export class DayType extends CustomCode {

  public static _registered = new Map<string, DayType>();
  static MONDAY = new DayType('MONDAY',1);
  static TUESDAY = new DayType('TUESDAY',2);
  static WEDNESDAY = new DayType('WEDNESDAY',3);
  static THURSDAY = new DayType('THURSDAY',4);
  static FRIDAY = new DayType('FRIDAY',5);
  static SATURDAY = new DayType('SATURDAY',6);
  static SUNDAY = new DayType('SUNDAY',0);

  static ALL = Array.from(DayType._registered.values());

  private _momentCode: number;

  static retrieveFromCode(code: string): DayType {
    const res = DayType._registered.get(''+code);
    if (!res) {
      if (DayType._registered.has(code)){
        console.log('DayType is there but cant be found');
      }else{
        console.log('DayType not found.');
      }
      // console.log('code is type : ' + (typeof code) + ' ' + JSON.stringify(code,null,2));
      console.log('Hmmm DayType can\'t find >' + code+ '< ' + (typeof code));
      for (const bean of Array.from(DayType._registered.values())){
        console.log('Registered: >' + bean.code + '< ' + (typeof bean.code) );
      }
    }else{
       // console.log('DayType '+code+' has been found!');
    }
    return res;
  }
  public static retrieveFromDate(refDate: Date): DayType {
    const m = moment(refDate).day();
    return DayType.retrieveFromMomentCode(m);
  }

  public static retrieveFromMomentCode(m: number): DayType {
    switch (m) {
      case 0: return DayType.SUNDAY;
      case 1: return DayType.MONDAY;
      case 2: return DayType.TUESDAY;
      case 3: return DayType.WEDNESDAY;
      case 4: return DayType.THURSDAY;
      case 5: return DayType.FRIDAY;
      case 6: return DayType.SATURDAY;
    }
  }


  constructor(code: string, momentCode: number) {
    super(code);
    this._momentCode = momentCode;
    DayType._registered.set(code, this);
    // console.log('Registering >' + code + '<');
  }

  public get momentCode(): number{
    return this._momentCode;
  }

  public toTranslateKey(): string{
    return 'DAY_TYPE_' + this.code;
  }

  /**
   * Tiny Hack to reorder dayOfWeek when changing startOfWeek...
   * Used ONLY when ordering the Availabilities and als.
   * ex: StartOf Week is a Wednesday (Should become 0) meaning Thursday becomes 1 and Tuesday 6.
   */
  public orderWhenWeekStartOn(startWeek: DayType): number {
    if (startWeek.momentCode > this._momentCode){
      return this._momentCode + 7 - startWeek.momentCode;
    }else{
      return this._momentCode - startWeek.momentCode;
    }
  }

  public static nextInOrder(idx:number, startWeek: DayType): DayType {
    if (startWeek.momentCode + idx < 7){
      return DayType.retrieveFromMomentCode(startWeek.momentCode + idx);
    }else{
      const val = idx - 7 + startWeek.momentCode;
      return DayType.retrieveFromMomentCode(val);
    }

  }

  public static order(startWeek: DayType): DayType[] {
    const res = new Array<DayType>();
    for (let idx = 0; idx<7; idx++){
      res.push(DayType.nextInOrder(idx,startWeek));
    }
    return res;
  }


}



export class AvailableJobAggregation {
  availableJobWithUnit = new Array<JobAndUnitInfo>();
  divisions = new Array<Unit>();

  _createFromArray(propertyName: string, data: any) {
    const serializer = new JSonSerializer();
    if ('availableJobWithUnit' === propertyName) {
      for (const bean of <JobAndUnitInfo[]> data) {
        const tmp = new JobAndUnitInfo();
        serializer.deserialize(bean, tmp);
        this.availableJobWithUnit.push(tmp);
      }
    }
    if ('divisions' === propertyName) {
      for (const bean of <Unit[]> data) {
        const tmp = new Unit();
        serializer.deserialize(bean, tmp);
        this.divisions.push(tmp);
      }
    }
  }

}

export class WorkCodeData {
  country: string;
  state: string;
  minimumWage: number;
  delayNoticeOfDismissalInWeeks: number;
  vacationPercentage: number;
  vacationDays: number;
  weeklyOvertimeThreshold: number;
}


export class ModalResult extends CustomCode{
  public static OK = new ModalResult('OK');
  public static CANCEL = new ModalResult('CANCEL');
  public static YES = new ModalResult('YES');
  public static NO = new ModalResult('NO');
  public static OTHER = new ModalResult('OTHER');
  public static UPDATED = new ModalResult('UPDATED');

}

/*

export class HorariusTimeZone extends CustomCode{
  public static _registered = new Map<string, HorariusTimeZone>();

  static  CA_EASTERN = new HorariusTimeZone('CA_EASTERN');
  static  CA_ATLANTIC = new HorariusTimeZone('CA_ATLANTIC');
  static  CA_CENTRAL = new HorariusTimeZone('CA_CENTRAL');
  static  CA_MOUNTAIN = new HorariusTimeZone('CA_MOUNTAIN');
  static  CA_PACIFIC = new HorariusTimeZone('CA_PACIFIC');
  static  CENTRAL_EUROPEAN = new HorariusTimeZone('CET');

static ALL = Array.from(HorariusTimeZone._registered.values());

constructor(code: string) {
  super(code);
  HorariusTimeZone._registered.set(code, this);
}
static retrieveFromCode(code: string): HorariusTimeZone {
  const res = HorariusTimeZone._registered.get(code);
  if (!res) {
    console.log('HorariusTimeZone can\'t be found with code: ' + code);
    return null;
  }
  return res;
}

public toTranslateKey(): string{
  return 'HORARIUS_TZ_' + this.code;
}
}


*/

export class TimesheetType extends CustomCode{
  public static _registered = new Map<string, TimesheetType>();

  static TRAVAIL = new TimesheetType('TRAVAIL', 'T',true);
  static ENTRAINEMENT = new TimesheetType('ENTRAINEMENT', 'E',true);
  static JOUR1CSST = new TimesheetType('JOUR1CSST', 'A',true);
  // static ABSAUTHNONPAYE = new TimesheetType('ABSAUTH', 'B',false);
  static ABSAUTHNONPAYE = new TimesheetType('ABSAUTHNONPAYE', 'B',false);
  static ABSAUTHPAYE = new TimesheetType('ABSAUTHPAYE', 'C',true);
  static ABSNONAUTH = new TimesheetType('ABSNONAUTH', 'D',false);
  static ABSMALPAYE = new TimesheetType('ABSMALPAYE', 'G',true);
  static ABSMALNONPAYE = new TimesheetType('ABSMALNONPAYE', 'H',false);
  static ABSDECPAYE = new TimesheetType('ABSDECPAYE', 'I',true);
  static ABSDECNONPAYE = new TimesheetType('ABSDECNONPAYE', 'J',false);
  static ABSFAM = new TimesheetType('ABSFAM', 'K',false);
  static ABSFAM_PAID = new TimesheetType('ABSFAM_PAID', 'K2',true);

  static FERIE  = new TimesheetType('FERIE', 'F',true);
  static VACANCE = new TimesheetType('VACANCE', 'V',true);
  static FORMATION = new TimesheetType('FORMATION', 'L',true);
  static CONGE_AVEC_SOLDE = new TimesheetType('CONGE_AVEC_SOLDE', 'S',true);
  static BANK_TYPE = new TimesheetType('BANK_TYPE', 'BT',true);




  static OTHER = new TimesheetType('OTHER', 'O',true);
  static UNION_RELATED = new TimesheetType('UNION_RELATED', 'UR',true);

  static ALL = Array.from(TimesheetType._registered.values());
  static ALL_NO_BANK_TYPE = [TimesheetType.TRAVAIL,TimesheetType.ENTRAINEMENT,TimesheetType.JOUR1CSST,TimesheetType.ABSAUTHNONPAYE,TimesheetType.ABSAUTHPAYE,
    TimesheetType.ABSNONAUTH,TimesheetType.ABSMALPAYE,TimesheetType.ABSMALNONPAYE,TimesheetType.ABSDECPAYE,TimesheetType.ABSDECNONPAYE,TimesheetType.ABSFAM,TimesheetType.ABSFAM_PAID,
    TimesheetType.FERIE,TimesheetType.VACANCE,TimesheetType.FORMATION,TimesheetType.CONGE_AVEC_SOLDE,TimesheetType.OTHER,TimesheetType.UNION_RELATED
  ];


  shortCode: string;
  paid = false;
  constructor (code: string, shortCode: string, paid: boolean) {
    super(code)
    this.shortCode = shortCode;
    this.paid = paid;
    TimesheetType._registered.set(code, this);
  }

  public static sort(translate: TranslateService,codes: TimesheetType[]): TimesheetType[]{
   return codes.sort((a:TimesheetType,b:TimesheetType)=>{
      return translate.instant(a.code).localeCompare(translate.instant(b.code));
    });

  }




  public static remove(toRemove: TimesheetType,codes: TimesheetType[]): TimesheetType[]{
    const res = new Array<TimesheetType>();
    for (const tt of codes){
      if (tt.code !== toRemove.code){
        res.push(tt);
      }
    }
    return res;


  }



  public static isAmong(toSearch: TimesheetType, ...codes: TimesheetType[]): boolean {
    for (const c of codes) {
      if (toSearch === c) {
        return true;
      }
    }
    return false;
  }

  static retrieveFromCode(code: string): TimesheetType {
    const res = TimesheetType._registered.get(code);
    if (!res) {
      console.log('TimesheetType can\'t be found with code: ' + code);
      return null;
    }
    return res;
  }

  needsToSpecifyHours(): boolean{
    switch (this.code){
      case TimesheetType.ABSAUTHNONPAYE.code:
        return false;
      case TimesheetType.ABSNONAUTH.code:
        return false;
      case TimesheetType.ABSMALNONPAYE.code:
        return false;
      case TimesheetType.ABSDECNONPAYE.code:
        return false;
      case TimesheetType.ABSFAM.code:
        return false;
      case TimesheetType.ABSFAM_PAID.code:
        return false; // Calculation is done with a specific formula.
      case TimesheetType.VACANCE.code:
        return false;
      case TimesheetType.BANK_TYPE.code:
        return false;
      // case TimesheetType.ABSMALPAYE.code:
      //   return false;
      case TimesheetType.FERIE.code:
        return false;
    }

    return true;

  }



  /*

  isTimesheetDoesNotNeedToSpecifyHours():boolean{
    let res = false;
    if (this.tsType){
      switch (this.tsType){
        // case TimesheetType.CONGE_AVEC_SOLDE:
        //   res=true; break;
        case TimesheetType.ABSAUTHNONPAYE:
          res=true; break;
        // case TimesheetType.ABSAUTHPAYE:
        //   res=true; break;
        case TimesheetType.ABSFAM:
          res=true; break;
        case TimesheetType.ABSMALNONPAYE:
          res=true; break;
        // case TimesheetType.ABSMALPAYE:
        //   res=true; break;
        case TimesheetType.ABSDECNONPAYE:
          res=true; break;
        // case TimesheetType.ABSDECPAYE:
        //   res=true; break;
        case TimesheetType.ABSNONAUTH:
          res=true; break;
        case TimesheetType.VACANCE:
          res=true; break;
        case TimesheetType.FERIE:
          res=true; break;
      }
    }
    // console.log('isTimesheetSomeKindOfAbsence: ' + res + ' type: ' + this.data.tsType);
    return res;
  }

   */



}

export class ScheduleType extends CustomCode{
  public static _registered = new Map<string, ScheduleType>();
  static TRAVAIL = new ScheduleType('TRAVAIL', 'T');
  static FERIE  = new ScheduleType('FERIE', 'F');
  static CONGE_SANS_SOLDE  = new ScheduleType('CONGE_SANS_SOLDE', 'C');
  static ENTRAINEMENT = new ScheduleType('ENTRAINEMENT', 'E');
  static FORMATION = new ScheduleType('FORMATION', 'O');
  static VACANCE = new ScheduleType('VACANCE', 'V');
  static CONGE_AVEC_SOLDE = new ScheduleType('CONGE_AVEC_SOLDE', 'S');
  static SICK_LEAVE_PAID = new ScheduleType('SICK_LEAVE_PAID', 'SKP');
  static SICK_LEAVE_UNPAID = new ScheduleType('SICK_LEAVE_UNPAID', 'SKUP');

  static BEREAVEMENT_LEAVE_PAID = new ScheduleType('BEREAVEMENT_LEAVE_PAID', 'SKP');
  static BEREAVEMENT_LEAVE_UNPAID = new ScheduleType('BEREAVEMENT_LEAVE_UNPAID', 'SKUP');
  static FAMILY_LEAVE_PAID = new ScheduleType('FAMILY_LEAVE_PAID', 'FLP');
  static FAMILY_LEAVE_UNPAID = new ScheduleType('FAMILY_LEAVE_UNPAID', 'FLUP');

  static BANK_TYPE = new ScheduleType('BANK_TYPE', 'BT');



  static ALL = Array.from(ScheduleType._registered.values());
  static ALL_NO_BANK = [ScheduleType.TRAVAIL,ScheduleType.FERIE,ScheduleType.CONGE_SANS_SOLDE,ScheduleType.ENTRAINEMENT,ScheduleType.FORMATION,ScheduleType.VACANCE,ScheduleType.CONGE_AVEC_SOLDE,
    ScheduleType.SICK_LEAVE_PAID,ScheduleType.SICK_LEAVE_UNPAID,ScheduleType.BEREAVEMENT_LEAVE_PAID,ScheduleType.BEREAVEMENT_LEAVE_UNPAID,ScheduleType.FAMILY_LEAVE_PAID,ScheduleType.FAMILY_LEAVE_UNPAID];
  static ALL_NO_VACATION = [ScheduleType.TRAVAIL,ScheduleType.FERIE,ScheduleType.CONGE_SANS_SOLDE,ScheduleType.ENTRAINEMENT,ScheduleType.FORMATION,ScheduleType.CONGE_AVEC_SOLDE,ScheduleType.BANK_TYPE,
    ScheduleType.SICK_LEAVE_PAID,ScheduleType.SICK_LEAVE_UNPAID,ScheduleType.BEREAVEMENT_LEAVE_PAID,ScheduleType.BEREAVEMENT_LEAVE_UNPAID,ScheduleType.FAMILY_LEAVE_PAID,ScheduleType.FAMILY_LEAVE_UNPAID];
  // static ALL_NO_VACATION_AND_NO_BANK = [ScheduleType.TRAVAIL,ScheduleType.FERIE,ScheduleType.CONGE_SANS_SOLDE,ScheduleType.ENTRAINEMENT,ScheduleType.FORMATION,ScheduleType.CONGE_AVEC_SOLDE,ScheduleType.BANK_TYPE];
  static ALL_NO_VACATION_AND_NO_BANK = [ScheduleType.TRAVAIL,ScheduleType.FERIE,ScheduleType.CONGE_SANS_SOLDE,ScheduleType.ENTRAINEMENT,ScheduleType.FORMATION,ScheduleType.CONGE_AVEC_SOLDE,
    ScheduleType.SICK_LEAVE_PAID,ScheduleType.SICK_LEAVE_UNPAID,ScheduleType.BEREAVEMENT_LEAVE_PAID,ScheduleType.BEREAVEMENT_LEAVE_UNPAID,ScheduleType.FAMILY_LEAVE_PAID,ScheduleType.FAMILY_LEAVE_UNPAID];

  shortCode: string;
  constructor (code: string, shortCode: string) {
    super(code);
    this.shortCode = shortCode;
    ScheduleType._registered.set(code, this);
  }


  public static isAmong(toSearch: string, ...codes: ScheduleType[]): boolean {
    for (const c of codes) {
      if (toSearch === c.code) {
        return true;
      }
    }
    return false;
  }

  static retrieveFromCode(code: string): ScheduleType {
    const res = ScheduleType._registered.get(code);
    if (!res) {
      console.log('ScheduleType can\'t be found with code: ' + code);
      return null;
    }
    return res;
  }

  public toTimesheetType(): TimesheetType{
    switch (this){
      case ScheduleType.TRAVAIL: return TimesheetType.TRAVAIL;
      case ScheduleType.FERIE: return TimesheetType.FERIE;
      case ScheduleType.CONGE_SANS_SOLDE: return TimesheetType.ABSAUTHNONPAYE;
      case ScheduleType.ENTRAINEMENT: return TimesheetType.ENTRAINEMENT;
      case ScheduleType.FORMATION: return TimesheetType.FORMATION;
      case ScheduleType.VACANCE: return TimesheetType.VACANCE;
      case ScheduleType.CONGE_AVEC_SOLDE: return TimesheetType.CONGE_AVEC_SOLDE;
      case ScheduleType.BANK_TYPE: return TimesheetType.BANK_TYPE;
      case ScheduleType.SICK_LEAVE_PAID: return TimesheetType.ABSMALPAYE;
      case ScheduleType.SICK_LEAVE_UNPAID: return TimesheetType.ABSMALNONPAYE;
    }
    return null;
  }




  needsToSpecifyHours(): boolean{
    switch (this.code){
      case ScheduleType.TRAVAIL.code:
        return true;
      case ScheduleType.BANK_TYPE.code:
        return true;
      case ScheduleType.ENTRAINEMENT.code:
        return true;
      case ScheduleType.FORMATION.code:
        return true;
    }
    return false;
  }


  public static sort(translate: TranslateService,codes: ScheduleType[]): ScheduleType[]{
    return codes.sort((a:ScheduleType,b:ScheduleType)=>{
      return translate.instant(a.code).localeCompare(translate.instant(b.code));
    });

  }

}



export class IndustryClassification extends CustomCode{
  public static _registered = new Map<string, IndustryClassification>();
  static MANUFACTURING_31 = new IndustryClassification('MANUFACTURING_31',31);
  static CAR_AND_PART_DEALER_441 = new IndustryClassification('CAR_AND_PART_DEALER_441',441);
  static GROCERIES_445 = new IndustryClassification('GROCERIES_445',445);
  static PHARMACIES_446 = new IndustryClassification('PHARMACIES_446',446);
  static SPORTING_HOBBY_STORE_451 = new IndustryClassification('SPORTING_HOBBY_STORE_451',451);
  static GENERAL_STORE_452 = new IndustryClassification('GENERAL_STORE_452',452);
  static TRANSPORT_48 = new IndustryClassification('TRANSPORT_48',48);
  static TRANSPORT_AIR_481 = new IndustryClassification('TRANSPORT_AIR_481',481);
  static TRANSPORT_WATER_483 = new IndustryClassification('TRANSPORT_WATER_483',483);
  static TRANSPORT_TRUCK_484 = new IndustryClassification('TRANSPORT_TRUCK_484',484);
  static WAREHOUSE_493 = new IndustryClassification('WAREHOUSE_493',493);

  static DESIGN_SERVICE_5414 = new IndustryClassification('DESIGN_SERVICE_5414',5414);
  static VETERINARY_SERVICE_54194 = new IndustryClassification('VETERINARY_SERVICE_54194',54194);

  static PHYSICIANS_OFFICES_6211 = new IndustryClassification('PHYSICIANS_OFFICES_6211',6211);
  static NURSING_RESIDENTIAL_FACILITIES_623 = new IndustryClassification('NURSING_RESIDENTIAL_FACILITIES_623',623);

  static FOOD_SERVICES_AND_DRINKING_PLACES_722 = new IndustryClassification('FOOD_SERVICES_AND_DRINKING_PLACES_722',722);
  static PERSONAL_CARE_SERVICES_8121 = new IndustryClassification('PERSONAL_CARE_SERVICES_8121',8121);

  static UNKNOWN = new IndustryClassification('UNKNOWN',0);

  static ALL = Array.from(IndustryClassification._registered.values());
  private _naics = 0;
  constructor (code: string, naics:number) {
    super(code);
    this._naics = naics;
    IndustryClassification._registered.set(code, this);
  }


  static retrieveFromCode(code: string): IndustryClassification {
    const res = IndustryClassification._registered.get(code);
    if (!res) {
      console.log('IndustryClassification can\'t be found with code: ' + code);
      return null;
    }
    return res;
  }

  toTranslateKey():string{
    return this.code;
  }

  get naics(){
    return this._naics;
  }

}



